import {arrayToSet} from "../../../js/atUtils";
import GroupController from "../../../js/groupManagement/group_controller";
import {APUserGroupManagementController} from "../../../js/groupManagement/base_group_management_controller";
import LeaveBalanceEditorContent from '../../../js/administration/userManagement/LeaveBalanceEditorContent'
import BalanceHistoryPanelContent from '../../../js/BalanceHistoryPanelContent'
import BalanceRulesEditorDialogContent from '../../../js/controls/BalanceRulesEditorDialogContent'

function UserListPage(){
    this.constructor =  UserListPage;
}

UserListPage.BOTTOM_BAR_HEIGHT = 26;

UserListPage.prototype.init = function(pageData, pageState, currentUserId, weekStartDay, currentUserTZGroupId, exportBalanceHistoryUrl)
{
    var that = this;

    this._weekStartDay = weekStartDay;
    this._ptoHoursPerDay = pageData.ptoHoursPerDay;
    this._userSettingsUpdateRequestObjects = {};
    this.userIdRowMap = {};

    this._currentUserId = currentUserId;
    this._findElementsInDocument();

    this._initUserRolesPopup();

    this._spinnerController = new SpinnerController();

    // Note: state controller must to contain only page controls, which must be reverted if server requests failed
    this._stateController = new StateController().init( pageState );
    this._stateController.addOnSaveStateActions( function ( state )
                                                 {
                                                     if (that._isUGREnabled() || that._isTZGEnabled())
                                                        that._userGroupsSelector.saveState();
                                                     that._renderUserListControls( state, false );
                                                 } );

    this._stateController.addOnLoadStateActions( function ( state )
                                                 {
                                                     if (that._isUGREnabled() || that._isTZGEnabled())
                                                         that._userGroupsSelector.loadState();
                                                     that._renderUserListControls( state, true );
                                                 } );

    this.warningsController = new WarningsController();

    function _updateUserListIfNecessary()
    {
        //noinspection JSPotentiallyInvalidUsageOfThis
        var input = that._userNameFilterInput.getInnerInputElement();
        if( input.prevValue != input.value)
        {
            input.prevValue = input.value;
            that._stateController.setProperty( 'userNameFilterText', that._userNameFilterInput.getSearchString() );
            that._stateController.setProperty( 'pageNum', 1 );
            that._updateUserListWithDelay( 200, 'spinnerPlaceholder' );
        }
    }
    function typingFilterNameFn( event )
    {
        var input = that._userNameFilterInput.getInnerInputElement();
        if( event.keyCode == KEY_CODE_ESC && input.value != "")
        {
            input.value ="";
        }
        _updateUserListIfNecessary();
    }
    function clearTypedNameFn()
    {
        _updateUserListIfNecessary();
    }
    this._userNameFilterInput = new FilterWordsField().initAndRender(
            typingFilterNameFn,
            $( ".userNameInputContainer" )[0],
            "actiplans.user_list.js.start_typing_name",
            clearTypedNameFn
    );

    function highlightCellWithActiveFilterFunc( cell )
    {
        return function ( active )
        {
            if( active )
            {
                cell.addClass( "highlightedCellWithActiveFilter" );
            }
            else
            {
                cell.removeClass( "highlightedCellWithActiveFilter" );
            }
        };
    }

    this._viewerSettings = pageData.viewerSettings;
    this._ptoCalculationEnabled = pageData.ptoCalculationEnabled;
    this._sickBalanceCalculationEnabled = pageData.sickBalanceCalculationEnabled;

    if ( !this._ptoCalculationEnabled && !this._sickBalanceCalculationEnabled )
    {
        this._hideManageBalanceColumn();
    }

    if ( this._isUGREnabled() || this._isTZGEnabled() )
    {
        var userGroupsWrappersList = this._isUGREnabled() ? this._getGroupWrappersList(pageData.allUserGroups, makeMapForEntitiesArray( pageData.allUserGroups ),
                                                                                       pageState.userListFilter.groupType == GroupType.USER_GROUP ? pageState.userListFilter.groupIds : [], true, SystemSettings.usersWithoutGroupId) : null;
        var timeZoneGroupsWrappersList = this._isTZGEnabled() ? this._getGroupWrappersList(pageData.allTimeZoneGroups, makeMapForEntitiesArray( pageData.allTimeZoneGroups ),
                                                                                           pageState.userListFilter.groupType == GroupType.TIME_ZONE_GROUP ? pageState.userListFilter.groupIds : [], false, DEFAULT_TIME_ZONE_GROUP_ID) : null;
        this._userGroupsSelector = new ItemSelector(
                '.userGroupsFilterPlaceholder',
                this._self( this._onGroupSelectionChanged ),
                AT.ExtendedGroupsSelectorPanel,
                null,
                false,
                {
                    userGroupsData: userGroupsWrappersList,
                    timeZoneGroupsData: timeZoneGroupsWrappersList,
                    groupType: pageState.userListFilter.groupType
                },
                true
        );
        this._userGroupsSelector.setOnUpdateStateFunction( highlightCellWithActiveFilterFunc( $( '#userListTableHeaderCell_usernameCell' ) ) );
    }

    this._onlyUsersWithoutApproversCaption.click(
            function (){
                var userListFilter = that._stateController.getProperty( "userListFilter" );
                userListFilter.onlyUsersWithoutApprovers = true;
                userListFilter.groupIds = null;
                userListFilter.statusFilter = UserListPageConstants.USER_STATUS_FILTER_ENABLED_ONLY;
                userListFilter.rolesFilter = UserListPageConstants.USER_ROLES_FILTER_ALL;

                that._stateController.setProperty("userListFilter",  userListFilter );
                that._stateController.setProperty("userNameFilterText", "" );
                if (that._isUGREnabled() || that._isTZGEnabled())
                    that._userGroupsSelector.getPanel().selectAll();

                that._userNameFilterInput.clearInputValue();
                that._accountStatusFilterCheckbox.attr( 'checked', false );
                that._accountStatusFilterCheckbox.attr('disabled', true);

                that._onlyManagersFilterCheckbox.attr( 'checked', false );
                that._onlyManagersFilterCheckbox.attr( 'disabled', true );

                that._updateUserList('spinnerPlaceholder', true);
            }
    );

    this._cancelOnlyUsersWithoutApproversButton.click(
            function (){
                var userListFilter = that._stateController.getProperty( "userListFilter" );
                userListFilter.onlyUsersWithoutApprovers = false;
                that._stateController.setProperty( userListFilter );
                that._accountStatusFilterCheckbox.attr('disabled', false);
                that._onlyManagersFilterCheckbox.attr('disabled', false);
                that._updateUserList('spinnerPlaceholder', true);
            }
    );

    this._accountStatusFilterCheckbox.change( function () {
        that._accountStatusSortDataHolder.attr( 'disabled', !this.checked );
        $(that._accountStatusSortDataHolder).toggleClass( "disabledSortButton", !this.checked );
    });

    this._accountStatusFilterCheckbox.click(
            function ()
            {
                var userListFilter = that._stateController.getProperty( "userListFilter" );
                userListFilter.statusFilter = this.checked ?
                                              UserListPageConstants.USER_STATUS_FILTER_ALL :
                                              UserListPageConstants.USER_STATUS_FILTER_ENABLED_ONLY;
                that._stateController.setProperty( userListFilter );
                that._stateController.setProperty( 'pageNum', 1 );
                that._updateUserList('spinnerPlaceholder', true);
            }
    );

    this._onlyManagersFilterCheckbox.click(
            function ()
            {
                var userListFilter = that._stateController.getProperty( "userListFilter" );
                userListFilter.rolesFilter = this.checked ?
                                              UserListPageConstants.USER_ROLES_FILTER_MANAGERS_ONLY :
                                              UserListPageConstants.USER_ROLES_FILTER_ALL;
                that._stateController.setProperty( userListFilter );
                that._stateController.setProperty( 'pageNum', 1 );
                that._updateUserList('spinnerPlaceholder', true);
            }
    );

    this._pagerController = new PagerController().init(
            {
                pagerData: this._stateController.getProperties( ['pageNum', 'totalRecords', 'recordsPerPage'] ),
                handlersMap: {
                    pageChanged: function ( pageNum )
                    {
                        that._stateController.setProperty( 'pageNum', pageNum );
                        that._updateUserList('spinnerPlaceholderPager');
                    },
                    recordsPerPageChanged: function ( recordsPerPage )
                    {
                        that._stateController.setProperty( 'recordsPerPage', recordsPerPage );
                        that._pagerController.loadPage( 1 );
                    }
                },
                pagerControlsElementId: "pagerPanel",
                pagerElementId: "pager",
                recordsPerPageSelectorId: "recordsPerPageSelector",
                minRecordsPerPage: MIN_RECORDS_PER_PAGE
            }
    );
    this._pagerController.render();

    var self = this;

    this._manageDepartmentsButton.click( function () {
        self._showManageDepartmentsPopup( function ( departmentController ) {  self._manageDepartmentsPopupClosedAndSmthChanged( departmentController ) } );
    } );
    
    // time zone group of logged in user
    var previousLoggedInUserTZGroup = _.find(
            pageData.allTimeZoneGroups,
            function(tzGroup)
            {
                return tzGroup.id == currentUserTZGroupId;
            }
    );

    this._manageTimeZoneGroupsButton.click(function()
                                           {
                                               self._showManageTimeZoneGroupsPopup(
                                                       function(timeZoneGroupController)
                                                       {
                                                           // get actual time zone group off logged in user
                                                           var newLoggedInUserTZGroup = _.find(
                                                                   timeZoneGroupController.storedData,
                                                                   function(tzGroupWithUsers)
                                                                   {
                                                                       var tzGroupUserIds = _.map(tzGroupWithUsers.users, function(user)
                                                                       {
                                                                           return user.id;
                                                                       });
                                                                       return _.contains(tzGroupUserIds, currentUserId);
                                                                   }
                                                           );
                                                           // check new and prev tz group of logged in user
                                                           if (previousLoggedInUserTZGroup.id != newLoggedInUserTZGroup.id ||
                                                               previousLoggedInUserTZGroup.timeZoneId != newLoggedInUserTZGroup.timeZoneId ||
                                                               previousLoggedInUserTZGroup.cityName != newLoggedInUserTZGroup.cityName)
                                                           {
                                                               // update user list if his time zone group will be changed
                                                               alert(messageResource.getMessage('userlist.js.time_zone_was_changed'));
                                                               document.location.reload();
                                                               return;
                                                           }
                                                           self._manageTimeZoneGroupsPopupClosedAndSmthChanged(timeZoneGroupController)
                                                       }
                                               );
                                           });



    this._initTabs();

    this._userListHeader.find( '.sortButton' ).click(
            function ()
            {
                var parent = $( this ).parent();
                if ( parent.attr("disabled") )
                    return;

                that._onSortButtonClick( parent.attr( "data-sortBy" ), parent.attr( "data-spinnerPlaceholder" ) );
            } );

    this._getManageApproversDataRequestObject = null;

    this._approversDialog = new ApproversDialog().init(
        {
            submit: function ( dialogInfo, isAutoApproved, selectedApproverIds )
            {
                self._sendAssignApproversRequest( dialogInfo, isAutoApproved, selectedApproverIds );
            },
            loadData: function ( dialogInfo, dataLoadedCallback, loadingFailedCallback )
            {
                that._getManageApproversDataRequestObject = makeRpcCall(
                        "UserManagementService.getManageApproversData", [dialogInfo.userId],
                        function ( manageApproversData )
                        {
                            var targetRow = dialogInfo.targetRow;
                            targetRow.data().record.requiresApproval = manageApproversData.userRequiresApproval;

                            var approversSortingProcessor = self._createApproversSortingProcessor( manageApproversData.allApprovers );
                            targetRow.data().userApprovers = approversSortingProcessor( manageApproversData.userApproverIds );

                            that._updateApprovedByCellContent( targetRow );
                            if ( manageApproversData.allApprovers.length == 0 )
                            {
                                that._setAllUsersAutoApproved();
                            }

                            dataLoadedCallback( manageApproversData.allApprovers,
                                                !manageApproversData.userRequiresApproval,
                                                manageApproversData.userApproverIds );
                        },
                        function ( jqXHR, textStatus, errorThrown )
                        {
                            if( textStatus == 'abortDataLoading' )
                            {
                                return true;
                            }
                            if( errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException' )
                            {
                                alert( messageResource.getMessage( 'actiplans.user_list.error_user_was_deleted' ) );
                                UserListPage.removeRow( dialogInfo.targetRow );
                                loadingFailedCallback();
                                return true;
                            }
                            loadingFailedCallback();
                        }
                );
            },
            abortDataLoading: function ()
            {
                if( that._getManageApproversDataRequestObject != null )
                {
                    that._getManageApproversDataRequestObject.abort( 'abortDataLoading' );
                }
            }
        }, 360);

    this._getAssignUsersToApproverDataRequestObject = null;
    this._usersForApproverDialog = new UsersForLTRApproverDialog().init({
        dialogWidth: 438,
        dialogId: "usersForApproverDialog",
        panelConstructor: AT.UsersForLTRApproverSelectorPanel,
        abortDataLoading: function() {
            if( that._getAssignUsersToApproverDataRequestObject != null )
                that._getAssignUsersToApproverDataRequestObject.abort( 'abortDataLoading' );
        },
        userGroupsEnabled: self._isUGREnabled(),
        timeZoneGroupsEnabled: self._isTZGEnabled(),

        loadData: function ( dialogInfo, dataLoadedCallback ) {
            that._getAssignUsersToApproverDataRequestObject = makeRpcCall(
                "UserManagementService.getUsersAssignedToApprover", [dialogInfo.userId],

                function ( assignedUsersData ) {
                    if ( checkReloadNeededAfterGetAssignedUsersRequest(assignedUsersData, self._isUGREnabled(), self._isTZGEnabled(),self._usersForApproverDialog) ) {
                        document.location.reload();
                        return;
                    }

                    that._updateUsersForApproverDataAndCell( dialogInfo.targetRow, assignedUsersData.canManageAllUsers, assignedUsersData.numberOfAssignedUsers );

                    dataLoadedCallback(assignedUsersData);

                    PageOverlayTipsManager.getInstance().refreshDynamicTips();
                },

                function ( jqXHR, textStatus, errorThrown ) {
                    if( textStatus == 'abortDataLoading' )
                        return true;

                    if( errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException' )
                    {
                        alert( messageResource.getMessage( 'actiplans.user_list.error_user_was_deleted' ) );
                        UserListPage.removeRow( dialogInfo.targetRow );
                        self._usersForApproverDialog.close();
                        return true;
                    }
                    else if( errorThrown.exception == 'com.actimind.actitime.services.NoRightsToManageAccountSettings' )
                    {
                        alert( messageResource.getMessage( 'actiplans.user_list.error_cant_create_user_account' ) );
                        document.location.reload();
                        return true;
                    }

                    self._usersForApproverDialog.close();
                    return false;
                }
            );
        },
        saveData: function ( dialogInfo, canManageAllUsers, selectedUserIds ) {
            self._sendAssignUsersRequest( dialogInfo, canManageAllUsers, selectedUserIds, self._visibleOnPageUserIds );
        }

    });

    this._licenseCounterManager = new LicenseCounterManager().init( document.getElementById("licenseCountId") );

    this.ptoRulesManager = new BalanceRulesEditorDialogContent({
        leaveBalanceTypePrefix: "pto",
        balanceDefaults: pageData.ptoDefaults,
        countHoursPerDay: this._ptoHoursPerDay,
        parameters: {
            defaultMessageNoteKey: "pto_rules_editor.info.default",
            titleNoteKey: "pto_rules_editor.use_accrual_rules",
            customMessageNoteKey: "pto_rules_editor.info.custom",
            customTitleTooltip: "pto_rules_editor.custom_rules",
            defaultTitleTooltip: "pto_rules_editor.default_rules"
        }
    }).init(this._pageContent)

    this.sickRulesManager = new BalanceRulesEditorDialogContent({
        leaveBalanceTypePrefix: "sick",
        balanceDefaults: pageData.sickDefaults,
        countHoursPerDay: this._ptoHoursPerDay,
        parameters: {
            defaultMessageNoteKey: "sick_rules_editor.info.default",
            titleNoteKey: "sick_rules_editor.use_accrual_rules",
            customMessageNoteKey: "pto_rules_editor.info.custom",
            customTitleTooltip: "sick_rules_editor.custom_rules",
            defaultTitleTooltip: "sick_rules_editor.default_rules"
        }
    }).init(this._pageContent)

    this._balanceHistoryPanel = new BalanceHistoryPanelContent({
        exportBalanceHistoryUrl
    }).init(this._pageContent)
    this.$tableContainerEl = $("#balanceHistoryTableBodyDiv");

    this._updatePage( pageData );
    this._renderUserListControls( pageState, true );

    this._balanceEditor = new LeaveBalanceEditorContent().init(this._pageContent)

    // Even Actiplans may not be Online version (can be demo)
    this._addButtonStrategy = isOlVersion ?
                              new AddButtonOnlineStrategy().init(this._addUserButton,
                                                                 this._self(this._onCreateUserButtonClicked),
                                                                 this._self(this._onInviteSeveralUsersButtonClicked)):
                              new AddButtonDownloadableStrategy().init(this._self(this._onCreateUserButtonClicked));

    PageOverlayTipsManager.setInstance(new APUserListPageOverlayTipsManager({
        ptoEnabled: this._ptoCalculationEnabled,
        sickEnabled: this._sickBalanceCalculationEnabled,
        ugrEnabled: this._isUGREnabled(),
        tzgEnabled: this._isTZGEnabled()
    }));

    return this;
};

UserListPage.prototype._initTabs = function(){
    var self = this;
    if(!this.activeTabValue)
        this.activeTabValue = self._loadActiveTabNum();

    if (this._viewerSettings.allowedToManageLeaveBalanceSettings && ( this._ptoCalculationEnabled || this._sickBalanceCalculationEnabled ) )
    {
        var items = [];
        items.push({id:'tabAccountSettings',text: "userlist.tabs.account_settings", value:UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM});
        if ( this._ptoCalculationEnabled )
            items.push({id:'tabPTOSettings',text: "userlist.tabs.users_pto", value:UserListPageConstants.PTO_SETTINGS_TAB_NUM});
        if ( this._sickBalanceCalculationEnabled )
            items.push({id:'tabSickDaysSettings',text: "userlist.tabs.users_sick_days", value:UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM});

        this.tabs = new UserlistTabs().init(
                {
                    id: "userListTabs",
                    items: items,
                    activeTabValue: self.activeTabValue,
                    changeCallback: function ()
                    {
                        self._toggleTableClassForTabs( self.tabs.getActiveTab() );
                        $.cookie( "actiPLANS-userlist-tabs", self.tabs.getActiveTab(), {expires: 4000} );
                    }
                }
        );
        this._pageContent.addClass("wide");
    }
    if (!this._viewerSettings.allowedToManageLeaveBalanceSettings && ( this._ptoCalculationEnabled || this._sickBalanceCalculationEnabled ) ){
        this._pageContent.addClass("middle");
    }

    self._toggleTableClassForTabs(this.activeTabValue);
};

UserListPage.prototype._sendAssignApproversRequest = function ( dialogInfo, isAutoApproved, selectedApproverIds )
{
    var self = this;
    this._callUserManagementService(
            dialogInfo.targetRow, 'UserManagementService.assignApproversToUser',
            [ dialogInfo.userId, isAutoApproved , selectedApproverIds, self._visibleOnPageUserIds ],
            UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVED_BY, null,
            function (userManagementResult)
            {
                var approversSortingProcessor = self._createApproversSortingProcessor( userManagementResult.allApprovers );
                $.each( userManagementResult.additionalUsersInfo, function () {
                    var userInfo = this;
                    var row = self.userIdRowMap[userInfo.id];
                    if( row )
                    {
                        row.data().record = userInfo;
                        row.data().userApprovers = approversSortingProcessor( userManagementResult.approverIdsMap.map[userInfo.id] );
                        self._updateRow(row);
                    }
                });

                self._updateThereAreUsersWithoutApproversSetting( userManagementResult.thereAreUsersWithoutApprovers );

                self._approversDialog.hideAfterSaving();
                self._highlightRow(dialogInfo.targetRow);
                
                PageOverlayTipsManager.getInstance().refreshDynamicTips();
            },
            function ( jqXHR, textStatus, errorThrown )
            {
                if( errorThrown.exception == 'com.actimind.common.administration.SomeOfSelectedApproversNotValidException' )
                {
                    var allApprovers = errorThrown.allApprovers;
                    if ( allApprovers.length == 0 )
                    {
                        alert( messageResource.getMessage( "actiplans.user_list.approvers_dialog.error.no_leave_request_managers" ) );
                        self._setAllUsersAutoApproved();
                    }
                    else
                        alert(messageResource.getMessage('actiplans.user_list.some_of_selected_users_are_no_longer_approvers'));

                    var targetRow = dialogInfo.targetRow;
                    var approversSortingProcessor = self._createApproversSortingProcessor( allApprovers );
                    var actualApprovers = approversSortingProcessor( selectedApproverIds );
                    targetRow.data().userApprovers = actualApprovers;

                    self._updateApprovedByCellContent( targetRow );

                    var actualApproverIds = [];
                    for( var i = 0; i < actualApprovers.length; i++ )
                    {
                        actualApproverIds.push( actualApprovers[i].id );
                    }
                    self._approversDialog.update( allApprovers, isAutoApproved, actualApproverIds );
                    return true;
                }
                if( errorThrown.exception == 'com.actimind.actiplans.administration.NoLeaveTimeManagerException' )
                {
                    alert( messageResource.getMessage( "actiplans.user_list.approvers_dialog.error.no_leave_request_managers" ) );
                    self._approversDialog.hideAfterSaving();
                    self._setAllUsersAutoApproved();
                    return true;
                }
                self._approversDialog.hideAfterSaving();
            }
    );
};

UserListPage.prototype._sendAssignUsersRequest = function ( dialogInfo, canManageAllUsers, selectedUserIds, usersToUpdate )
{
    var self = this;
    this._callUserManagementService(
            dialogInfo.targetRow, 'UserManagementService.assignUsersToApprover',
            [ dialogInfo.userId, canManageAllUsers, selectedUserIds, usersToUpdate ],
            UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVER_FOR, null,
            function (userManagementResult) {
                self._updateApprovedByCellContentForRows( usersToUpdate, userManagementResult.allApprovers,
                                                          userManagementResult.approverIdsMap.map, userManagementResult.autoapprovalUsers.set );

                self._updateThereAreUsersWithoutApproversSetting( userManagementResult.thereAreUsersWithoutApprovers );

                self._usersForApproverDialog.hideAfterSaving();
                self._highlightRow(dialogInfo.targetRow);
            },
            function ( jqXHR, textStatus, errorThrown ) {
                if( errorThrown.exception == 'com.actimind.actitime.user.NoSuchUsersException')
                {
                    alert( messageResource.getMessage('userlist.js.error_all_selected_useds_deleted') );
                    self._deleteUsers( selectedUserIds );
                    self._usersForApproverDialog.refreshData( dialogInfo, true );
                    return true;
                }
                self._usersForApproverDialog.hideAfterSaving();
            }
    );
};

UserListPage.prototype._updateThereAreUsersWithoutApproversSetting = function ( newThereAreUsersWithoutApprovers )
{
    this._thereAreUsersWithoutApprovers = newThereAreUsersWithoutApprovers;
    if( this._thereAreUsersWithoutApprovers )
        this._pageContent.addClass( "thereAreUsersWithoutApprovers" );
    else
        this._pageContent.removeClass( "thereAreUsersWithoutApprovers" );
};

UserListPage.prototype._hideManageBalanceColumn = function()
{
    this._manageBalanceColumnHidden = true;
    var table = $( "#userListTable" );
    table.find( "col.accountTab-manageBalance-col").remove();
    table.find( "th.accountTab-manageRolesCell").attr( "colspan", 3 );
    table.addClass( "manageBalanceColumnHidden" );
    this._spacer.find( "td.accountTabCell").last().remove();
};

UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_CONTROL_STATUS = 1;
UserListPage.USER_SETTINGS_UPDATE_KEY_ACCOUNT_STATUS = 2;
UserListPage.USER_SETTINGS_UPDATE_KEY_BALANCE_MANAGER_ROLE = 3;
UserListPage.USER_SETTINGS_UPDATE_KEY_LEAVE_TIME_MANAGER_ROLE = 4;
UserListPage.USER_SETTINGS_UPDATE_KEY_ACCOUNT_SETTINGS_MANAGER_ROLE = 5;
UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_RULES = 6;
UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_BALANCE = 7;
UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVED_BY = 8;
UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVER_FOR = 9;

UserListPage.prototype._onGroupSelectionChanged = function ( selection ){
        var userListFilter = this._stateController.getProperty( "userListFilter" );
        userListFilter.groupIds = selection;
        userListFilter.groupType = this._userGroupsSelector.getPanel().getGroupType();
        this._stateController.setProperty( userListFilter );
        this._stateController.setProperty( "pageNum", 1 );
        this._updateUserList('spinnerPlaceholder', true);
};

UserListPage.prototype._isUGREnabled = function (){
    return this._viewerSettings.userGroupsEnabled;
};

UserListPage.prototype._isTZGEnabled = function (){
    return this._viewerSettings.timeZoneGroupsEnabled;
};

UserListPage.prototype._onUGRChanged = function(showAlert){
    this._abortAllRequests();
    if (showAlert)
    {
        if (!this._isUGREnabled()) {
            alert(messageResource.getMessage("actiplans.user_list.js.error.user_groups_enabled"));
        } else {
            alert(messageResource.getMessage("actiplans.user_list.js.error.user_groups_disabled"));
        }
    }
    document.location.reload();
};

UserListPage.prototype._onTZGChanged = function(showAlert){
    this._abortAllRequests();
    if (showAlert)
    {
        if (!this._isTZGEnabled()) {
            alert(messageResource.getMessage("actiplans.user_list.js.error.time_zone_groups_enabled"));
        } else {
            alert(messageResource.getMessage("actiplans.user_list.js.error.time_zone_groups_disabled"));
        }
    }
    document.location.reload();
};

UserListPage.prototype._validateIsChangeRightsManageBalanceAndAccountSettings = function(pageData){
    var msgKey="";

    var currentPTOEnabled = pageData.viewerSettings.ptoEnabled;
    var currentSDBEnabled = pageData.viewerSettings.sickBalanceEnabled;

    var ptoChanged =  this._viewerSettings.ptoEnabled != currentPTOEnabled;
    var sickChanged =  this._viewerSettings.sickBalanceEnabled != currentSDBEnabled;

    var alertMessageKey = null;

    if(ptoChanged && sickChanged){
        if(currentPTOEnabled && currentSDBEnabled){ // both features on
            alertMessageKey = "userlist.js.pto_and_sick_enabled";
        } else if(!currentPTOEnabled && !currentSDBEnabled) { // both features off
            alertMessageKey = "userlist.js.pto_and_sick_disabled";
        } else {
            // show alert only for pto
            if(currentPTOEnabled){
                alertMessageKey = "userlist.js.pto_enabled";
            } else {
                alertMessageKey = "userlist.js.pto_disabled";
            }
        }
    } else {
        if(ptoChanged){
            if(currentPTOEnabled){
                alertMessageKey = "userlist.js.pto_enabled";
            } else {
                alertMessageKey = "userlist.js.pto_disabled";
            }
        }
        if(sickChanged){
            if(currentSDBEnabled) {
                alertMessageKey = "userlist.js.sick_balance_enabled";
            } else {
                alertMessageKey = "userlist.js.sick_balance_disabled";
            }
        }
    }
    // if there is message show alert and reload page
    if(alertMessageKey){
        alert(messageResource.getMessage(alertMessageKey));
        document.location.reload();
        return true; // is changing
    }

    var newAllowedToManageLeaveBalanceSettings = pageData.viewerSettings.allowedToManageLeaveBalanceSettings;
    if (this._viewerSettings.allowedToManageLeaveBalanceSettings != newAllowedToManageLeaveBalanceSettings ){
        this._viewerSettings.allowedToManageLeaveBalanceSettings = newAllowedToManageLeaveBalanceSettings;

        if( pageData.ptoCalculationEnabled && pageData.sickBalanceCalculationEnabled )
            msgKey = newAllowedToManageLeaveBalanceSettings ? "userlist.js.error_have_right_to_view_pto_and_sick_tabs" : "userlist.js.error_no_right_to_view_pto_and_sick_tabs";
        else if( pageData.ptoCalculationEnabled )
            msgKey = newAllowedToManageLeaveBalanceSettings ? "userlist.js.error_have_right_to_view_pto_tab" : "userlist.js.error_no_right_to_view_pto_tab";
        else if( pageData.sickBalanceCalculationEnabled )
            msgKey = newAllowedToManageLeaveBalanceSettings ? "userlist.js.error_have_right_to_view_sick_tab" : "userlist.js.error_no_right_to_view_sick_tab";

        if (msgKey)
            alert(messageResource.getMessage(msgKey));
        if(newAllowedToManageLeaveBalanceSettings)
            document.location.reload();
        return true; // is changing
    }
    var newAllowedToManageAccountSettings = pageData.viewerSettings.allowedToManageAccountSettings;
    if (this._viewerSettings.allowedToManageAccountSettings != newAllowedToManageAccountSettings ){
        msgKey = newAllowedToManageAccountSettings ? "userlist.js.error_have_right_to_manage_account" : "userlist.js.error_no_right_to_view_account_tab_readonly";
        alert(messageResource.getMessage(msgKey));
        document.location.reload();
        return true;
    }
    return false;
};

UserListPage.prototype.setAddUserButtonStyleAccordingToLicense = function ( license ){

    if(! license.licenseViolated ){
        this._addUserButton.click(this._self(function() {this._addButtonStrategy.callback()}));
        $( this._addUserButton ).removeClass("buttonIsDisabled");
    }
    else
    {
        this._addUserButton.off();
        $( this._addUserButton ).addClass("buttonIsDisabled");
    }

};

UserListPage.prototype._updatePage = function ( pageData, showAlertOnReload )
{
    var visibleUsers = [];
    $.each( pageData.records, function () { visibleUsers.push(this.id); } );

    this._visibleOnPageUserIds = visibleUsers;
    this._stateController.setProperty( 'pageNum', pageData.pageNum );
    this._stateController.setProperty( 'totalRecords', pageData.totalRecords );
    this._weekStartDay = pageData.weekStartDay;
    this._ptoHoursPerDay = pageData.ptoHoursPerDay;
    this._ptoFormatter = new PTOFormatter().init( this._ptoHoursPerDay );
    this._ptoBalanceFormatter = new PTOFormatter().init( this._ptoHoursPerDay, SystemSettings.roundPTOBalanceOnUserlist );
    this._sickBalanceFormatter = new SickFormatter().init( this._ptoHoursPerDay, SystemSettings.roundSickBalanceOnUserlist );

    if ( this.ptoRulesManager )
        this.ptoRulesManager.reinitAccrualRulesControls( this._ptoHoursPerDay );

    if ( this.sickRulesManager )
        this.sickRulesManager.reinitAccrualRulesControls( this._ptoHoursPerDay );

    if (this._isUGREnabled() != pageData.viewerSettings.userGroupsEnabled)
    {
        this._onUGRChanged(showAlertOnReload);
        return;
    }
    if (this._isTZGEnabled() != pageData.viewerSettings.timeZoneGroupsEnabled)
    {
        this._onTZGChanged(showAlertOnReload);
        return;
    }

    this._validateIsChangeRightsManageBalanceAndAccountSettings(pageData);

    this._viewerSettings = pageData.viewerSettings;
    this._ptoCalculationEnabled = pageData.ptoCalculationEnabled;
    this._sickBalanceCalculationEnabled = pageData.sickBalanceCalculationEnabled;
    this._thereAreUsersWithoutApprovers = pageData.thereAreUsersWithoutApprovers;

    this._setClassesForPage();
    this._setLastColumnClass();
    this._userWorkScheduleTooltip.hide();
    this._approversTooltip.hide();

    var state = this._stateController.getState();
    var userGroupsWrapperList = null;
    var selectedIds;

    function mapSelectedGroups(groups) {
        return _.map(_.filter(groups||[],function(group) {
                return group.selected;
            }),function(group) {
                return group.id;
            });
    }

    if ( pageData.allUserGroups )
    {
        this._allUserGroups = pageData.allUserGroups;
        this._userGroupIdToGroupMap = makeMapForEntitiesArray( pageData.allUserGroups );

        // GroupType defined in constants_js.jsp
        selectedIds = state.userListFilter.groupType==GroupType.USER_GROUP?
                      state.userListFilter.groupIds:
                      // may be we have it stored somewhere?
                      mapSelectedGroups(this._userGroupsSelector._panel.userGroupsData);
        userGroupsWrapperList = this._getGroupWrappersList(this._allUserGroups, this._userGroupIdToGroupMap, selectedIds, true, SystemSettings.usersWithoutGroupId);
    }
    var tzGroupsWrapperList = null;
    if ( pageData.allTimeZoneGroups )
    {
        this._allTimeZoneGroups = pageData.allTimeZoneGroups;
        this._timeZoneGroupIdToGroupMap = makeMapForEntitiesArray( pageData.allTimeZoneGroups );
        // GroupType defined in constants_js.jsp
        selectedIds = state.userListFilter.groupType==GroupType.TIME_ZONE_GROUP?
                      state.userListFilter.groupIds:
                      // may be we have it stored somewhere?
                      mapSelectedGroups(this._userGroupsSelector._panel.timeZoneGroupsData);
        tzGroupsWrapperList = this._getGroupWrappersList(this._allTimeZoneGroups, this._timeZoneGroupIdToGroupMap, selectedIds, false, DEFAULT_TIME_ZONE_GROUP_ID);
    }
    if (this._isUGREnabled() || this._isTZGEnabled())
    {
        this._userGroupsSelector.getPanel().updateGroupsData(userGroupsWrapperList, tzGroupsWrapperList);
    }

    this._updateUserListRows( pageData.records, pageData.allApprovers, pageData.approverIdsMap );

    var license = pageData.licenseCounters;
    this._licenseCounterManager.setAllowedToView(this._viewerSettings.allowedToManageAccountSettings);
    this._licenseCounterManager.setLicenseCounter( license );
    this._licenseCounterManager.update();

    this.setAddUserButtonStyleAccordingToLicense( license );

    PageOverlayTipsManager.getInstance().refreshDynamicTips();
};

UserListPage.prototype._renderUserListControls = function ( state, includeImmediatelyControls )
{
    this._accountStatusFilterCheckbox.attr( 'checked', state.userListFilter.statusFilter == UserListPageConstants.USER_STATUS_FILTER_ALL );
    this._accountStatusFilterCheckbox.change();

    this._onlyManagersFilterCheckbox.attr( 'checked', state.userListFilter.rolesFilter == UserListPageConstants.USER_ROLES_FILTER_MANAGERS_ONLY );
    this._onlyManagersFilterCheckbox.change();

    this._pagerController.setPagerStateAndUpdateUI(
            state.totalRecords,
            state.pageNum,
            state.recordsPerPage
    );
    this._totalRecordsPlaceholder.text( state.totalRecords );

    if( includeImmediatelyControls )
    {
        this._userNameFilterInput.setInputValue( state.userNameFilterText );
    }

    this._userListHeader.find( '[data-sortBy]' ).removeClass( "ascending descending" );
    this._userListHeader.find( '[data-sortBy=' + state.sortBy + ']' )
            .addClass( state.isAscending ? "ascending" : "descending" );
};

UserListPage.prototype._findElementsInDocument= function (){
    this._pageContent = $("#userListPageContent");
    this._userListHeader = $("#userListTable").find("> thead");
    this._userListBody = $("#userListTable").find(".actualContent");
    this._requestTemplate = $("tbody.templates .userRow");
    this._noUsersRowTemplate = $( "tbody.templates .noUsersRow" );
    this._selectAccountsTabButton = $(".accountsTabButton");
    this._selectPtoTabButton = $(".ptoTabButton");
    this._totalRecordsPlaceholder = $('#totalRecordsPlaceholder');
    this._accountStatusFilterCheckbox = $('#userList_accountEnabledFilter');
    this._onlyManagersFilterCheckbox = $('#userList_onlyManagersFilter');
    this._manageRolesInfoButton = $('.accountTab-manageRoles-manageInfoImg-span');
    this._addUserButton = this._pageContent.find('.addUserButton');
    this._manageDepartmentsButton = this._pageContent.find('.editDepartmentsLink');
    this._manageTimeZoneGroupsButton = this._pageContent.find('.editTimeZoneGroupsLink');
    this._userWorkScheduleTooltip = $('#userWorkScheduleTooltip');
    this._tablePlaceholder =  this._userWorkScheduleTooltip.find("#userWorkScheduleTooltip_durationsTablePlaceholder");
    this._weekTextPlaceholder =  this._userWorkScheduleTooltip.find("#userWorkScheduleTooltip_weekTextPlaceholder");
    this._scheduleHeader =  this._userWorkScheduleTooltip.find("#userWorkScheduleTooltip_scheduleHeader");
    this._approversTooltip = new ApproversTooltip().init( "approversTooltip" );
    this._usersForApproverTooltip = $( '#usersForApproverTooltip' );
    this._spacer =  $(".templates .apUserListSpacer");
    this._onlyUsersWithoutApproversCaption =  $("#onlyUsersWithoutApproversCaption");
    this._cancelOnlyUsersWithoutApproversButton =  $("#cancelOnlyUsersWithoutApproversButton");
    this._accountStatusSortDataHolder =  $("#accountStatusSortDataHolder");

};

UserListPage.prototype._self = function ( func ){
    var self = this;

    return function (){
        return func.apply(self, arguments);
    }
};

UserListPage.prototype._initUserRolesPopup = function () {
    var popupDiv = $("#userRolesPopupDiv");
    var infoButton = this._manageRolesInfoButton;

    var manageRolesInfoPopup = new DropdownDialog({
                                             wrapperClass: 'userRolesPopup',
                                             dialogDiv: popupDiv,
                                             hideButtons: true,
                                             isWithBeak: true,
                                             hideOnResize: true
                                         });

    this._manageRolesInfoButton.click( function() {
        manageRolesInfoPopup.showAt(this, {offset: "-60px 7px", collision: "none"});
    });
};

UserListPage.prototype._toggleTableClassForTabs = function (activeTabValue){
    var isShowPTO = activeTabValue == UserListPageConstants.PTO_SETTINGS_TAB_NUM;
    var isShowSickDays = activeTabValue == UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM;
    var isShowAccountSettings = activeTabValue == UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM;
    this._pageContent.toggleClass( "selectPtoTab", isShowPTO);
    this._pageContent.toggleClass( "selectSickDaysTab", (isShowSickDays));
    this._pageContent.toggleClass( "selectAccountsTab", (isShowAccountSettings));
    this._setLastColumnClass();
};

UserListPage.prototype._loadActiveTabNum = function ()
{
    var tabNum = $.cookie("actiPLANS-userlist-tabs");
    if (!tabNum)
        tabNum = UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM;

    if(!this._ptoCalculationEnabled && tabNum == UserListPageConstants.PTO_SETTINGS_TAB_NUM)
        tabNum = UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM ;
    else if(!this._sickBalanceCalculationEnabled && tabNum == UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM)
        tabNum = UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM ;

    return tabNum;
};

UserListPage.prototype._setClassesForPage = function ()
{
    var classes = [];
    classes.push( this._viewerSettings.allowedToManageAccountSettings ? "allowedToManageAccountSettings" : "" );

    if( this._viewerSettings.allowedToManageLeaveBalanceSettings )
    {
        classes.push( "allowedToManageBalanceSettings" );
        if(this.tabs)
            this.tabs.show();
        else
            this._initTabs();
    }
    else
    {
       if(this.tabs) this.tabs.hide();
    }

    if( this._thereAreUsersWithoutApprovers )
        classes.push( "thereAreUsersWithoutApprovers" );

    if (!this._isUGREnabled())
        classes.push("ugrDisabled");

    if (!this._isTZGEnabled())
        classes.push("tzgDisabled");

    var filter = this._stateController.getProperty( "userListFilter" );

    if( filter.onlyUsersWithoutApprovers ) {
        classes.push( "onlyUsersWithoutApproversEnabled" );
        this._accountStatusFilterCheckbox.attr('disabled', true);
        this._onlyManagersFilterCheckbox.attr('disabled', true);
    } else {
        classes.push( "onlyUsersWithoutApproversDisabled" );
        this._accountStatusFilterCheckbox.attr('disabled', false);
        this._onlyManagersFilterCheckbox.attr('disabled', false);
    }

    if (
        this.tabs &&
        (this.tabs.getActiveTab()  == UserListPageConstants.PTO_SETTINGS_TAB_NUM || this.tabs.getActiveTab() == UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM ) &&
        !this._viewerSettings.allowedToManageLeaveBalanceSettings
    )
    {
        this.tabs.setActiveTab( UserListPageConstants.ACCOUNT_SETTINGS_TAB_NUM );
        this.tabs.updateUI();
    }

    classes.push(this.tabs && this.tabs.getActiveTab() == UserListPageConstants.PTO_SETTINGS_TAB_NUM ? "selectPtoTab" :
                 (this.tabs && this.tabs.getActiveTab() == UserListPageConstants.SICK_DAYS_SETTINGS_TAB_NUM ? "selectSickDaysTab" : "selectAccountsTab" ));

    this._pageContent.removeClass( "allowedToManageAccountSettings allowedToManageBalanceSettings selectAccountsTab selectPtoTab selectSickDaysTab ugrDisabled onlyUsersWithoutApproversEnabled onlyUsersWithoutApproversDisabled thereAreUsersWithoutApprovers" );
    this._pageContent.addClass( classes.join( " " ) );
};


UserListPage.prototype._setLastColumnClass= function ( ){

    this._userListHeader.find("th").removeClass("lastColumn");

    var firstRowLastColumn =  this._userListHeader.find("tr:first-child th:visible" ).last();

    firstRowLastColumn.addClass("lastColumn");

};

UserListPage.prototype._updateUserListRows = function ( userListRecordsArray, allApprovers, approverIdsMap )
{
    this._userListBody.html( "" );

    var self = this;
    var even = false;

    approverIdsMap = approverIdsMap.map;
    var approversSortingProcessor = allApprovers ? this._createApproversSortingProcessor( allApprovers ) : function(){};
    $.each( userListRecordsArray, function ()
    {
        self._createRowAtLastPosition( this, approversSortingProcessor( approverIdsMap[this.id] ), even );
        even = !even;
    } );

    if( userListRecordsArray.length == 0 )
    {
        this._createNoUsersRow();
    }
};

UserListPage.prototype._createApproversSortingProcessor = function ( allApprovers )
{
    return createApproversSortingProcessor( allApprovers );
};

UserListPage.prototype._createNoUsersRow = function ()
{
    var row = this._noUsersRowTemplate.clone();

    var userListFilter = this._stateController.getProperty( "userListFilter" );
    var enabledUsersFilter = userListFilter.statusFilter == UserListPageConstants.USER_STATUS_FILTER_ENABLED_ONLY;
    var groupsFilter = userListFilter.groupIds != null && userListFilter.groupIds != [];

    var noEnabledUsersMsgKey = groupsFilter ?
                               (userListFilter.groupType == GroupType.USER_GROUP ?
                                'userlist.js.users_table_no_enabled_users_found_in_selected_user_groups' :
                                'userlist.js.users_table_no_enabled_users_found_in_selected_time_zone_groups') :
                               'userlist.js.users_table_no_enabled_users_found';
    var noUsersMsgKey = groupsFilter ?
                        (userListFilter.groupType == GroupType.USER_GROUP ?
                         'userlist.js.users_table_no_users_found_in_selected_user_groups' :
                         'userlist.js.users_table_no_users_found_in_selected_time_zone_groups') :
                        'userlist.js.users_table_no_users_found';

    row.find( ".noUsersTextPlaceholder" ).html( messageResource.getMessage(enabledUsersFilter ? noEnabledUsersMsgKey : noUsersMsgKey) );

    row.appendTo( this._userListBody );
};

UserListPage.prototype._createRowAtFirstPosition = function ( record, userApprovers, even ){
    var newRow = this._createRow(record, userApprovers, even);
    newRow.prependTo(this._userListBody);
    return newRow;

};

UserListPage.prototype._createRowAtLastPosition = function ( record, userApprovers, even ){
    var newRow = this._createRow(record, userApprovers, even);
    newRow.appendTo( this._userListBody );
};

UserListPage.getTooltipOffsetByElement = function( jQueryEvent, tooltipEl )
{
    return calculateTooltipOffsetByItParameters(tooltipEl.outerHeight(), tooltipEl.outerWidth(), jQueryEvent, UserListPage.BOTTOM_BAR_HEIGHT);
};

UserListPage.getTooltipOffset = function( jQueryEvent, tooltip )
{
    return calculateTooltipOffset(tooltip, jQueryEvent, UserListPage.BOTTOM_BAR_HEIGHT);
};

UserListPage.prototype._createRow = function ( record, userApprovers, even){

    var self = this;
    var newRow = this._requestTemplate.clone();
    this.userIdRowMap[record.id] = newRow;
    newRow.data().record = record;
    newRow.data().userApprovers = userApprovers;

    var isCurrentUser = (record.id === this._currentUserId);
    this._setNewRowData(newRow, even);

    var ptoCellClass = ".ptoTabCell";
    var sickCellClass = ".sickDaysTabCell";

    newRow.find( ptoCellClass + ".balance-td" ).click( function (e) { self._onBalanceClicked(e, BalanceType.PTO ); } );
    newRow.find( ptoCellClass + ".userBalanceEnabled-td" ).click( function(e) { self._onUserPtoControlClicked(e, BalanceType.PTO); } );
    newRow.find( ptoCellClass + ".balanceHistoryShow-td" ).click(this._self(this._onShowPtoBalanceHistoryClicked));
    newRow.find( ptoCellClass + ".balanceHistoryShow-td" ).hover( function (e) { $(e.delegateTarget ).addClass("hovered"); }, function (e) { $(e.delegateTarget ).removeClass("hovered"); });
    newRow.find( ptoCellClass + ".accrueRule-td, " + ptoCellClass + ".resetRule-td, " + ptoCellClass + ".capRule-td" ).click( function(e) { self._onEditRulesClicked(e, BalanceType.PTO) } );

    newRow.find( ptoCellClass + ".accrueRule-td, " + ptoCellClass + ".resetRule-td, " + ptoCellClass + ".capRule-td" ).hover( function(e) {
                                                                                               self._showAccrualRulesTooltip(e, self.ptoRulesManager, "ptoData");
                                                                                               self._addAccrualRulesHoveredState(e, BalanceType.PTO);
                                                                                           },
                                                                                           function (e) {
                                                                                               self.ptoRulesManager.hideAccrualRulesTooltip();
                                                                                               self._removeAccrualRulesHoveredState(e);
                                                                                           }
    );
    newRow.find( ptoCellClass + ".accrueRule-td, " + ptoCellClass + ".resetRule-td, " + ptoCellClass + ".capRule-td" ).mousemove(function  (jQueryEvent) {
        self.ptoRulesManager.moveAccrualRulesTooltip(jQueryEvent);
    });


    newRow.find( sickCellClass + ".balance-td" ).click( function (e) { self._onBalanceClicked(e, BalanceType.SICK ); } );
    newRow.find( sickCellClass + ".userBalanceEnabled-td" ).click( function(e) { self._onUserPtoControlClicked(e, BalanceType.SICK); } );
    newRow.find( sickCellClass + ".balanceHistoryShow-td" ).click(this._self(this._onShowSickBalanceHistoryClicked));
    newRow.find( sickCellClass + ".balanceHistoryShow-td" ).hover( function (e) { $(e.delegateTarget ).addClass("hovered"); }, function (e) { $(e.delegateTarget ).removeClass("hovered"); });
    newRow.find( sickCellClass + ".accrueRule-td, " + sickCellClass + ".resetRule-td, " + sickCellClass + ".capRule-td" ).click( function(e) { self._onEditRulesClicked(e, BalanceType.SICK) } );

    newRow.find( sickCellClass + ".accrueRule-td, " + sickCellClass + ".resetRule-td, " + sickCellClass + ".capRule-td" ).hover( function(e) {
                                                                                                                                  self._showAccrualRulesTooltip(e, self.sickRulesManager, "sickDaysData");
                                                                                                                                  self._addAccrualRulesHoveredState(e, BalanceType.SICK);
                                                                                                                              },
                                                                                                                              function (e) {
                                                                                                                                  self.sickRulesManager.hideAccrualRulesTooltip();
                                                                                                                                  self._removeAccrualRulesHoveredState(e);
                                                                                                                              }
    );
    newRow.find( sickCellClass + ".accrueRule-td, " + sickCellClass + ".resetRule-td, " + sickCellClass + ".capRule-td" ).mousemove(function  (jQueryEvent) {
        self.sickRulesManager.moveAccrualRulesTooltip(jQueryEvent);
    });


    newRow.find(".accountTab-week-td" ).hover( function( e ) { self._showUserWorkScheduleTooltip(e, UserListPage.getTooltipOffsetByElement(e, self._userWorkScheduleTooltip)); } , function () { self._userWorkScheduleTooltip.hide(); });
    newRow.find(".accountTab-week-td" ).mousemove(function  ( e ) { self._userWorkScheduleTooltip.offset( UserListPage.getTooltipOffsetByElement(e, self._userWorkScheduleTooltip) ) } );

    newRow.find( ".accountTab-approvedBy-td" ).hover( function(e){ self._showApproversTooltip(e, UserListPage.getTooltipOffset(e, self._approversTooltip)) }, function () { self._approversTooltip.hide(); } );
    newRow.find( ".accountTab-approvedBy-td" ).mousemove( function ( e ) { self._approversTooltip.move( UserListPage.getTooltipOffset(e, self._approversTooltip) ) } );

    newRow.find( ".accountTab-usersForApproverSelector-td" ).hover( function(e){ self._showUsersForApproverTooltip(e, UserListPage.getTooltipOffsetByElement(e, self._usersForApproverTooltip)) }, function () { self._usersForApproverTooltip.hide(); } );
    newRow.find( ".accountTab-usersForApproverSelector-td" ).mousemove( function ( e ) { self._usersForApproverTooltip.offset( UserListPage.getTooltipOffsetByElement(e, self._usersForApproverTooltip) ) } );

    var approvedByCell =  newRow.find(".accountTab-approvedBy-td" );

    approvedByCell.click( function ( jQueryEvent ) {
        if( !self._viewerSettings.allowedToManageAccountSettings )
            return;

        self._abortRequestsBeforeUserSettingsUpdate( UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVED_BY );

        self._approversTooltip.hide();

        //do not use "record" variable that came from function args it's saved in closure
        //and if it changed later we won't see the changes!
        var recordNotInClosure =  newRow.data().record;
        newRow.addClass("selected");
        approvedByCell.addClass("dialogSelected");
        self._approversDialog.setOnCloseCallback( function ()
                                                  {
                                                      newRow.removeClass("selected");
                                                      approvedByCell.removeClass("dialogSelected");
                                                  } );
        self._approversDialog.showAt( {
                                          userId: recordNotInClosure.id,
                                          element: approvedByCell[0],
                                          offset: "0px 0px",
                                          targetRow: newRow
                                      } );

    });

    var approverForCell =  newRow.find(".accountTab-usersForApproverSelector-td");
    approverForCell.click( function ( jQueryEvent ) {
        var recordNotInClosure =  newRow.data().record;

        if ( !self._verifyCanAssignUsersToApprover(recordNotInClosure) )
            return;

        self._abortRequestsBeforeUserSettingsUpdate( UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVER_FOR );
        self._usersForApproverTooltip.hide();

        newRow.addClass("selected");
        approverForCell.addClass("dialogSelected");
        self._usersForApproverDialog.setOnCloseCallback( function ()
                                                  {
                                                      newRow.removeClass("selected");
                                                      approverForCell.removeClass("dialogSelected");
                                                  } );
        self._usersForApproverDialog.showAt( {
                                          userId: recordNotInClosure.id,
                                          element: approverForCell[0],
                                          offset: "0px 0px",
                                          targetRow: newRow,
                                          minimizedMode: recordNotInClosure.canManageAllUsers
                                      } );

    } );

    var setAccountStateButton = newRow.find(".accountTab-accountState-td" );
    var setAccountManagerButton = newRow.find(".accountTab-manageAccounts-td");
    var setLeaveBalanceManagerButton = newRow.find(".accountTab-manageBalance-td");
    if ( this._manageBalanceColumnHidden )
        setLeaveBalanceManagerButton.hide();
    var setRequestsManagerButton = newRow.find(".accountTab-manageRequests-td");
    var userNameText = newRow.find(".accountTab-userNameText-span" );

    this._createWarningsTooltip(newRow, record, true);

    if( record.id == this._currentUserId )
        newRow.addClass( "currentUserRow" );
    else
        newRow.removeClass( "currentUserRow" );

    if (this._viewerSettings.allowedToManageAccountSettings && !record.locked) {
        userNameText.click(  this._self( this._onEditUserClicked )  );

        if (record.id == this._currentUserId) {
            setAccountStateButton.attr( "title", messageResource.getMessage('userlist.cannot_disable_own_access') );
            setAccountManagerButton.attr( "title", messageResource.getMessage('user.edit.cannot_revoke_manage_users') );
        } else {
            setAccountStateButton.click(this._self(this._onAccountStateClicked));
            setAccountManagerButton.click(this._self(this._onSetAccountManagerButtonClicked));

            setAccountStateButton.addClass("activeButton");
            setAccountManagerButton.addClass("activeButton");
        }
        if ( !this._manageBalanceColumnHidden )
        {
            setLeaveBalanceManagerButton.click(this._self(this._onSetLeaveBalanceManagerButtonClicked));
            setLeaveBalanceManagerButton.addClass("activeButton");
        }
        setRequestsManagerButton.click(this._self(this._onSetRequestsManagerButtonClicked));
        setRequestsManagerButton.addClass("activeButton");
    }else if (record.locked){
        userNameText.attr( "title" ,messageResource.getMessage("user.edit.js.user_is_locked") );
        setAccountStateButton.attr( "title" ,messageResource.getMessage("actiplans.user_list.edit_status.user_is_locked") );
        setAccountManagerButton.attr( "title" ,messageResource.getMessage("actiplans.user_list.edit_rights.user_is_locked") );
        if ( !this._manageBalanceColumnHidden )
            setLeaveBalanceManagerButton.attr( "title" ,messageResource.getMessage("actiplans.user_list.edit_rights.user_is_locked") );
        setRequestsManagerButton.attr( "title" ,messageResource.getMessage("actiplans.user_list.edit_rights.user_is_locked") );
    }

    return newRow;
};

UserListPage.prototype._deleteUser = function(userId)
{
    UserListPage.removeRow(this.userIdRowMap[userId]);
};
UserListPage.prototype._deleteUsers = function(userIdsArray)
{
    for (var i = 0, usersLength = userIdsArray.length; i < usersLength; i++)
        try {
            this._deleteUser( userIdsArray[i] );
        }
        catch(e) {}// user with this id is not on this page, move on
};

UserListPage.prototype._setNewRowData = function( row, even ) {
    var userInfo = row.data().record;
    var userNameTokensHighlighter = this._getUserNameTokensHighlighter();

    this._fillInAccountSettingsData(row, userNameTokensHighlighter);
    this._fillInPtoSettingsData(row);
    this._fillInSickDaysSettingsData(row);

    this._createWarningsTooltip(row, userInfo, false);
    
    row.addClass( this._makeClassesForCreatedRow( userInfo, even ));
};

UserListPage.prototype._createWarningsTooltip = function(row, userInfo, isCreatingUser)
{
    var infoJQEl = row.find(".infoSpan").hide();
    var warningJQEl = row.find(".warningsInRow").hide();
    var warnings = userInfo.warnings;
    if (warnings && warnings.length > 0)
    {
        var noteMsgs = this._createWarningMsgs(userInfo, isCreatingUser);
        var infoMsgs = noteMsgs.infoMsgs;
        var warningMsgs = noteMsgs.warningMsgs;
        
        if (infoMsgs && infoMsgs.length > 0)
        {
            
            this.warningsController.setInfoHoverEvents(infoJQEl, infoMsgs);
            infoJQEl.show();
        }
        
        if (warningMsgs && warningMsgs.length > 0)
        {
            var warningSection = row.find(".warningsInRow");
            this.warningsController.setWarnings(warningSection, warningMsgs);
            warningJQEl.show();
        }
    }
    
};

UserListPage.prototype._updateManageRequestsRoleAndUsersForApproverCellContent = function ( row )
{
    var record = row.data().record;

    var manageRequestsButton = row.find(".accountTab-manageRequests-td");
    record.roles.allowedToManageRequests ? manageRequestsButton.addClass("canManage") : manageRequestsButton.removeClass("canManage");

    this._updateUsersForApproverCellContent(row);

    var assignUsersToManager = row.find(".accountTab-usersForApproverSelector-td");
    this._verifyCanAssignUsersToApprover(record) ? assignUsersToManager.addClass("activeButton") : assignUsersToManager.removeClass("activeButton");
};

UserListPage.prototype._updateUsersForApproverCellContent = function ( row )
{
    var record = row.data().record;
    var numberOfAssignedUsers = record.numberOfAssignedUsers;
    var text;

    if ( !record.roles.allowedToManageRequests )
        text = "--";
    else if (record.canManageAllUsers)
        text = messageResource.getMessage("user_list.manager.approves.all_users");
    else if (!numberOfAssignedUsers || numberOfAssignedUsers == 0)
        text = messageResource.getMessage("user_list.manager.approves.no_users");
    else if (numberOfAssignedUsers == 1)
        text = messageResource.getMessage("user_list.manager.approves.one_user");
    else
        text = messageResource.getMessage("user_list.manager.approves.n_users", [numberOfAssignedUsers]);

    row.find(".accountTab-usersForApproverSelector-td").html(text);
};

UserListPage.prototype._updateUsersForApproverDataAndCell = function ( row, newCanManageAllUsers, newNumberOfAssignedUsers )
{
    var record = row.data().record;
    record.canManageAllUsers = newCanManageAllUsers;
    record.numberOfAssignedUsers = newNumberOfAssignedUsers;

    this._updateUsersForApproverCellContent(row);
};

UserListPage.prototype._setApprovers = function ( targetRowData, allApprovers, selectedApproverIds ) {
    var approversSortingProcessor = this._createApproversSortingProcessor( allApprovers );
    targetRowData.userApprovers = approversSortingProcessor( selectedApproverIds );
};

UserListPage.prototype._updateApprovedByCellContentForRows = function ( usersToUpdate, allApprovers, approverIdsMap, autoapprovalUsers )
{
    var self = this;
    var usersToUpdateSet = arrayToSet(usersToUpdate);
    $.each(this._userListBody.find(".userRow"),
           function (index, row){
               var data = $(row).data();
               var record = data.record;
               if ( !!usersToUpdateSet[record.id] ) {
                   record.requiresApproval = !autoapprovalUsers[record.id];
                   self._setApprovers( data, allApprovers, approverIdsMap[record.id] );
                   self._updateApprovedByCellContent( $(row) );
               }
           }
    );
};

UserListPage.prototype._updateApprovedByCellContent = function ( row )
{
    var requiresApproval = row.data().record.requiresApproval;
    var userApprovers = row.data().userApprovers;
    var cellContent;
    var userIsLTM = row.data().record.roles.allowedToManageRequests;

    row.toggleClass( "userIsLTM", userIsLTM );

    row.removeClass( "automaticallyApprovedUser" );
    row.removeClass( "userIsWithoutApprovers" );

    if( requiresApproval )
    {
        if( userApprovers == null || userApprovers.length == 0 )
        {
            row.addClass( "userIsWithoutApprovers" );
            cellContent = messageResource.getMessage("actiplans.user_list.not_selected");
        }
        else
            cellContent = formatAssignApproversCellText(userApprovers);
    }
    else
    {
        row.addClass( "automaticallyApprovedUser" );
        cellContent = messageResource.getMessage("actiplans.user_list.automatically_approved");
    }
    row.find( ".accountTab-approvedByText-span" ).html( cellContent );
};

UserListPage.prototype._fillInPtoSettingsData= function (newRow){
    this._fillInBalanceSettingsData(newRow, newRow.data().record.ptoData, BalanceType.PTO);
};

UserListPage.prototype._fillInSickDaysSettingsData= function (newRow){
    this._fillInBalanceSettingsData(newRow, newRow.data().record.sickDaysData, BalanceType.SICK);
};

UserListPage.prototype._fillInBalanceSettingsData= function (newRow, data, balanceType){
    var balanceData = data;
    var balanceTypeCellClass;
    var balanceFormatter;
    var roundValue = false;
    if (balanceType == BalanceType.SICK)
    {
        balanceTypeCellClass = ".sickDaysTabCell";
        balanceFormatter = this._sickBalanceFormatter;
        roundValue = SystemSettings.roundSickBalanceOnUserlist;
    }
    if (balanceType == BalanceType.PTO)
    {
        balanceTypeCellClass = ".ptoTabCell";
        balanceFormatter = this._ptoBalanceFormatter;
        roundValue = SystemSettings.roundPTOBalanceOnUserlist;
    }
    var ptoControlText = balanceData ? messageResource.getMessage("common.on") : messageResource.getMessage("common.off");
    var  accrualRuleText;
    var  resetRuleText;
    var  capText;
    var  currentBalanceText;
    var  currentBalanceRevertedText;
    var  plannedBalanceApproved;
    var  plannedBalanceWaitingForApproval;

    if(balanceData){

        if (balanceData.defaultRules)
            accrualRuleText = balanceType == BalanceType.PTO ?
                              messageResource.getMessage("pto_rules_editor.default_pto_rules") :
                              messageResource.getMessage("sick_rules_editor.default_sick_rules");
        else {
            accrualRuleText = balanceData.accrualRule ? balanceFormatter.format(balanceData.accrualRule.value) + " " + CalendarFrequencyType.descriptionFor[balanceData.accrualRule.frequency.type] : "--";
            resetRuleText = balanceData.resetRule ? balanceFormatter.format( balanceData.resetRule.value ) + " " + (balanceData.resetRule.frequency.type == CalendarFrequencyType.ON_HIRE_DATE ?
                                                                                                                 CalendarFrequencyType.descriptionFor[balanceData.resetRule.frequency.type] :
                                                                                                                 "") + " " + CalendarFrequencyType.parametersFormatterFor[balanceData.resetRule.frequency.type]( balanceData.resetRule.frequency.params ) : "--";
            capText = balanceData.balanceCap != null ? balanceFormatter.format( balanceData.balanceCap ) : "--";
        }
        if (!balanceData.notStarted)
        {
            currentBalanceText = balanceFormatter.format(balanceData.balance);
            currentBalanceRevertedText = "(" + balanceFormatter.format(balanceData.balance, true) + ")";
        }
        else
        {
            currentBalanceText = "";
            currentBalanceRevertedText = messageResource.getMessage("common.not_available_lower");
        }
        plannedBalanceApproved = this._ptoFormatter.format(balanceData.plannedBalanceApproved) + " (" + this._ptoFormatter.format(balanceData.plannedBalanceApproved, true) + ")";
        plannedBalanceWaitingForApproval = this._ptoFormatter.format(balanceData.plannedBalanceWaitingForApproval) + " (" + this._ptoFormatter.format(balanceData.plannedBalanceWaitingForApproval, true) + ")";

    }else{
        accrualRuleText = "";
        resetRuleText = "";
        capText = "";
        currentBalanceText = "";
        currentBalanceRevertedText = "--";
        plannedBalanceApproved = "--";
        plannedBalanceWaitingForApproval = "--";
        // TODO: special CSS class for row to disable PTO hover effects
    }

    newRow.find(".userBalanceEnabled-td" + balanceTypeCellClass ).html( ptoControlText );
    newRow.find(".accrueRule-td" + balanceTypeCellClass ).html( accrualRuleText );
    newRow.find(".resetRule-td" + balanceTypeCellClass ).html( resetRuleText );
    newRow.find(".capRule-td" + balanceTypeCellClass ).html( capText );
    newRow.find( balanceTypeCellClass + " .balanceText-span" ).html( currentBalanceText );
    newRow.find( balanceTypeCellClass + " .balanceRevertedText-span" ).html( currentBalanceRevertedText );
    newRow.find(".plannedBalanceApproved-td" + balanceTypeCellClass ).html( plannedBalanceApproved );
    newRow.find(".plannedBalanceWaitingForApproval-td" + balanceTypeCellClass ).html( plannedBalanceWaitingForApproval );

    if (balanceData)
    {
        var isNegativePTO =  roundValue ? balanceData.balance <= -0.0625 : balanceData.balance <= -0.00125; //0.07 days is 1h (if round to whole number) 0.00125 days is 0.01h - otherwise
        newRow.find( balanceTypeCellClass + " .balanceText-span" ).toggleClass( "negative",isNegativePTO);
        newRow.find( balanceTypeCellClass + " .balanceRevertedText-span" ).toggleClass( "negative", isNegativePTO );
        newRow.find( ".balanceHistoryShow-td" + balanceTypeCellClass ).attr( "title", balanceType == BalanceType.PTO ?
                                                                                      messageResource.getMessage("common.pto_history.show_pto_history.tooltip.text") :
                                                                                      messageResource.getMessage("common.sick_history.show_sick_history.tooltip.text"));
        newRow.find( balanceTypeCellClass + ".balanceHistoryShow-td img" ).show();
    }
    else
    {
        newRow.find( ".balanceHistoryShow-td" + balanceTypeCellClass ).attr( "title", "");
        newRow.find( balanceTypeCellClass + ".balanceHistoryShow-td img" ).hide();
    }

    if (balanceData && balanceData.notStarted)
        newRow.find(".balance-td" + balanceTypeCellClass).attr("title", balanceType == BalanceType.PTO ?
                                                                        messageResource.getMessage("userlist.js.table.ptoCell.not_started") :
                                                                        messageResource.getMessage("userlist.js.table.sickCell.not_started"));
    else
        newRow.find(".balance-td" + balanceTypeCellClass).removeAttr("title");

    if (balanceData && balanceData.defaultRules)
    {
        newRow.find(".accrueRule-td" + balanceTypeCellClass ).attr( "colspan" , 3);
        newRow.find(balanceTypeCellClass + ".resetRule-td, " + balanceTypeCellClass + ".capRule-td" ).hide();
    }
    else
    {
        newRow.find(".accrueRule-td" + balanceTypeCellClass ).removeAttr( "colspan");
        newRow.find(balanceTypeCellClass + ".resetRule-td, " + balanceTypeCellClass + ".capRule-td" ).removeAttr( "style");
    }

};

UserListPage.prototype._fillInAccountSettingsData= function (newRow,  userNameTokensHighlighter ){
    var record = newRow.data().record;
    var userText = UserNameFormat.formatLFM( record.firstName, record.lastName, record.middleInitial );
    var weekText =  this._makeWeekText( record );

    var roles = record.roles;

    var manageAccountsButton = newRow.find(".accountTab-manageAccounts-td");

    if ( !this._manageBalanceColumnHidden )
    {
        var manageBalanceButton = newRow.find(".accountTab-manageBalance-td");
        roles.allowedToManageLeaveBalanceSettings ? manageBalanceButton.addClass("canManage") : manageBalanceButton.removeClass("canManage");
    }
    roles.allowedToManageAccountSettings ? manageAccountsButton.addClass("canManage") : manageAccountsButton.removeClass("canManage");
    this._updateManageRequestsRoleAndUsersForApproverCellContent( newRow );

    newRow.find(".accountTab-userNameText-span" ).html( userNameTokensHighlighter.highlightTokens(userText) );
    if (this._isUGREnabled())
        newRow.find(".accountTab-userGroupText-div").html(escapeHtmlSymbols(this._getGroupNameForRecord(record)));
    if (this._isTZGEnabled())
        newRow.find(".accountTab-timeZoneGroupText-div").html(escapeHtmlSymbols(this._getTimeZoneGroupNameForRecord(record)));
    newRow.find(".accountTab-weekText-span" ).html( weekText );
    newRow.find(".accountTab-accountStateText-span" ).html( this._makeAccountText( record ) );
    this._updateApprovedByCellContent( newRow );
};

UserListPage.prototype._getGroupNameForRecord = function ( record ){
    var groupName;

    if(this._userGroupIdToGroupMap[ record.userGroupId ])
        groupName =  this._userGroupIdToGroupMap[ record.userGroupId ].name;
    else
        groupName = null;

    return groupName ? groupName : messageResource.getMessage("actiplans.user_list.js.not_assigned");
};

UserListPage.prototype._getTimeZoneGroupNameForRecord = function(record){
    var timeZoneGroupName;

    if(this._timeZoneGroupIdToGroupMap[record.timeZoneGroupId])
        timeZoneGroupName =  this._timeZoneGroupIdToGroupMap[record.timeZoneGroupId].name;
    else
        timeZoneGroupName = null;

    return timeZoneGroupName ? timeZoneGroupName : " ";
};

UserListPage.prototype._makeWeekText= function ( record ){

    if( record.defaultWorkSchedule )
    {
        return "<span class='defaultText'>" + messageResource.getMessage("actiplans.user_list.js.default") +" </span> " +
               "<span class='week duration'>("
                       +UserTime.formatTime( record.workingWeekTotal ) +
               ")</span>";
    }
    else
    {
        return "<span class='week duration'> " +
                    UserTime.formatTime( record.workingWeekTotal ) +
               "</span>";
    }
};

UserListPage.prototype._makeAccountText= function ( record ){
    return record.enabled ? messageResource.getMessage( "actiplans.user_list.js.enabled" ) : messageResource.getMessage( "actiplans.user_list.js.disabled" );
};


UserListPage.prototype._makeClassesForCreatedRow= function ( record, even ){
    var classes = [];

    classes = classes.concat( record.enabled ? "enabledUser" : "disabledUser" );
    if ( record.enabledInOtherProduct != null )
    {
        classes = classes.concat( "linkedNotNull" );
        if ( record.enabledInOtherProduct == true )
            classes = classes.concat( "linkedWithActitime" );
    }
    classes = classes.concat( record.locked ? "locked" : "" );
    classes = classes.concat( even ? "even" : "odd" );
    classes = classes.concat( record.ptoData && !record.ptoData.notStarted ? "ptoON" : "" );
    classes = classes.concat( record.sickDaysData && !record.sickDaysData.notStarted ? "sickON" : "" );
    classes = classes.concat( record.ptoData ? "ptoHistoryOn" : "" );
    classes = classes.concat( record.sickDaysData ? "sickHistoryOn" : "" );
    classes = classes.concat( record.defaultWorkSchedule ? "userWithDefaultWorkSchedule" : "userWithCustomSchedule" );
    classes = classes.concat( record.ptoData && record.ptoData.defaultRules ? "userWithDefaultPtoRules" : "" );
    classes = classes.concat( record.sickDaysData && record.sickDaysData.defaultRules ? "userWithDefaultSickRules" : "" );
    classes = classes.concat( record.roles.allowedToManageRequests && !record.canManageAllUsers && record.numberOfAssignedUsers == 0 ? "approverWithoutAssignedUsers" : "" );

    return classes.join(" ");
};

UserListPage.prototype._updateRow = function( row ) {
    var even = row.hasClass("even");

    row.removeClass("enabledUser disabledUser locked ptoON sickON ptoHistoryOn sickHistoryOn userWithDefaultWorkSchedule userWithCustomSchedule userWithDefaultPtoRules userWithDefaultSickRules linkedNotNull linkedWithActitime approverWithoutAssignedUsers");
    this._setNewRowData(row, even);
};

UserListPage.prototype._updateRowAndTips = function( row ) {
    this._updateRow(row);
    PageOverlayTipsManager.getInstance().refreshDynamicTips();
};

UserListPage.prototype._updateGroupInAllRows = function(  ) {
    var self = this;
    $.each(this._userListBody.find(".userRow"),
           function (index, row){
               var groupNameText = self._getGroupNameForRecord( $(row).data().record );
               groupNameText = groupNameText ? groupNameText : messageResource.getMessage( 'common.users_without_group' );
               $(row).find(".accountTab-userGroupText-div" ).html( escapeHtmlSymbols( groupNameText ) );
           });
};

UserListPage.prototype._successHandler = function( userManagementResult ) {
    this._licenseCounterManager.setLicenseCounter( userManagementResult.licenseCounters );
    this._licenseCounterManager.update();

    if(!this._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups)){
        return false;
    }
    if(this._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult)){
        return false;
    }

    this.setAddUserButtonStyleAccordingToLicense( userManagementResult.licenseCounters );
    this._setClassesForPage();

    return true;
};

UserListPage.prototype._callUserManagementService = function( row, service, params, userSettingKey, spinnerContainerId,
                                                              customSuccessHandler, customErrorHandler ) {
    this._abortRequestsBeforeUserSettingsUpdate( userSettingKey );

    this._spinnerController.spin(spinnerContainerId);
    var self = this;
    var successHandler = customSuccessHandler ? this._self(customSuccessHandler) : null;
    var errorHandler = customErrorHandler ? this._self(customErrorHandler) : null;
    var resultHandler = new UserManagementResultHandler( row, this._self(this._updateRowAndTips),
                                                         function(userManagementResult) {
                                                             self._spinnerController.stop();
                                                             if(!self._successHandler(userManagementResult))
                                                                 return;
                                                             if (successHandler)
                                                                 successHandler(userManagementResult);
                                                         },
                                                         function(jqXHR, textStatus, errorThrown) {
                                                             self._spinnerController.stop();
                                                             if (errorHandler)
                                                                 return errorHandler(jqXHR, textStatus, errorThrown);
                                                             else
                                                                 return false;
                                                         } );

    this._userSettingsUpdateRequestObjects[userSettingKey] = makeRpcCall(service, params, resultHandler.successHandler, resultHandler.errorHandler);
};

UserListPage.prototype._onUserPtoControlClicked = function ( jQueryEvent, balanceType ) {
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;
    var balanceData = balanceType == BalanceType.PTO ? userInfo.ptoData : userInfo.sickDaysData;

    this._callUserManagementService(row, 'UserManagementService.setBalanceControlStatus', [userInfo.id, balanceType, balanceData === null],
                                    UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_CONTROL_STATUS, "spinnerPlaceholder");
};

UserListPage.prototype._onAccountStateClicked = function ( jQueryEvent ) {
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;

    this._sendSetAccountStateRequest( row, userInfo, false, false );
};

UserListPage.prototype._sendSetAccountStateRequest = function ( row, userInfo, forceChanges, setAllUsersAutoApprovedOnSuccess )
{
    var self = this;
    this._callUserManagementService(row, 'UserManagementService.setAccountStatus', [userInfo.id, !userInfo.enabled, forceChanges],
                                    UserListPage.USER_SETTINGS_UPDATE_KEY_ACCOUNT_STATUS, "spinnerPlaceholder",
                                    setAllUsersAutoApprovedOnSuccess ? function() { self._setAllUsersAutoApproved(); } : null,
                                    function(jqXHR, textStatus, errorThrown) {
                                        if( errorThrown.exception == 'com.actimind.common.administration.UserIsLastLeaveTimeManagerException' )
                                        {
                                            if( confirm( messageResource.getMessage( "actiplans.user_list.js.last_ltm_confirmation.disable" ) ) )
                                                self._sendSetAccountStateRequest( row, userInfo, true, true );
                                            return true;
                                        }
                                        return false;
                                    }
    );
};

UserListPage.prototype._onSetAccountManagerButtonClicked = function ( jQueryEvent ) {
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;

    this._callUserManagementService(row, 'UserManagementService.setUserRole',
        [userInfo.id, window.__GENERATED_CONSTANTS__.AccessRight.ACCOUNT_SETTINGS_MANAGER, !userInfo.roles.allowedToManageAccountSettings, false],
        UserListPage.USER_SETTINGS_UPDATE_KEY_ACCOUNT_SETTINGS_MANAGER_ROLE, "spinnerPlaceholder");
};

UserListPage.prototype._onSetLeaveBalanceManagerButtonClicked = function ( jQueryEvent ) {
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;

    var self = this;
    var updateTabs = ( userInfo.id == this._currentUserId ) ?
                        function() { self._updateUserList("spinnerPlaceholder"); }
                        : null;

    this._callUserManagementService(row, 'UserManagementService.setUserRole',
                                    [userInfo.id, window.__GENERATED_CONSTANTS__.AccessRight.LEAVE_BALANCE_MANAGER, !userInfo.roles.allowedToManageLeaveBalanceSettings, false],
                                    UserListPage.USER_SETTINGS_UPDATE_KEY_BALANCE_MANAGER_ROLE, "spinnerPlaceholder", updateTabs);
};

UserListPage.prototype._onSetRequestsManagerButtonClicked = function ( jQueryEvent ) {
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var userInfo = row.data().record;

    this._sendSetRequestsManagerRoleRequest( row, userInfo.id, !userInfo.roles.allowedToManageRequests, false, false );
};

UserListPage.prototype._sendSetRequestsManagerRoleRequest = function ( row, id, allowedToManageRequests, forceChanges, setAllUsersAutoApprovedOnSuccess ){
    var self = this;
    this._callUserManagementService(row, 'UserManagementService.setUserRole',
                                    [id, window.__GENERATED_CONSTANTS__.AccessRight.LEAVE_TIME_MANAGER, allowedToManageRequests, forceChanges],
                                    UserListPage.USER_SETTINGS_UPDATE_KEY_LEAVE_TIME_MANAGER_ROLE,
                                    "spinnerPlaceholder",
                                    setAllUsersAutoApprovedOnSuccess ? function() { self._setAllUsersAutoApproved(); } : null,
                                    forceChanges ? null : function( jqXHR, textStatus, errorThrown ) {
                                        if( errorThrown.exception == 'com.actimind.actiplans.administration.WaitingForApprovalRequestsExistException' )
                                        {
                                            var record = row.data().record;
                                            var name = UserNameFormat.formatFML( record.firstName, record.lastName, record.middleInitial );
                                            if( confirm( messageResource.getMessage( "actiplans.user_list.js.manage_requests_confirmation", [name] ) ) )
                                                self._sendSetRequestsManagerRoleRequest( row, id, allowedToManageRequests, true, false );
                                            return true;
                                        }
                                        if( errorThrown.exception == 'com.actimind.common.administration.UserIsLastLeaveTimeManagerException' )
                                        {
                                            if( confirm( messageResource.getMessage( "actiplans.user_list.js.last_ltm_confirmation.revoke_right" ) ) )
                                                self._sendSetRequestsManagerRoleRequest( row, id, false, true, true );
                                            return true;
                                        }
                                        return false;
                                    }
    );
};

UserListPage.prototype._abortGetEditUserDataRequest = function ()
{
    if( this._getEditUserDataRequestObject )
    {
        this._getEditUserDataRequestObject.abort();
    }
};

UserListPage.prototype._onEditUserClicked = function ( jQueryEvent ){

    this._abortAllRequests();
    var targetRow = $(jQueryEvent.delegateTarget).parents(".userRow" );
    var targetRowData = targetRow.data();
    var userId = targetRowData.record.id;

    this._showLoadingPopup();
    var self = this;
    this._getEditUserDataRequestObject = makeRpcCall( "UserManagementService.getEditUserData", [userId],
                 function ( editUserData ){
                     self._showEditUserPopup( editUserData, targetRow);
                 } ,
                 function ( jqXHR, textStatus, errorThrown )
                 {
                     self._hideLoadingPopup();

                     if( errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException' )
                     {
                         alert( messageResource.getMessage( 'actiplans.user_list.error_user_was_deleted' ) );
                         UserListPage.removeRow( targetRow );
                         return true;
                     }
                     if( errorThrown.exception == 'com.actimind.actitime.services.NoRightsToManageAccountSettings' )
                     {
                         alert( messageResource.getMessage( 'actiplans.user_list.noRightsForUserAccount' ) );
                         document.location.reload();
                         return true;
                     }
                     return false;
                 }
    );

};

UserListPage.prototype._showLoadingPopup = function ()
{
    this._loadingPopup = new LoadingPopup().init( "userDataLoadingPopup" );
    this._loadingPopup.show();
};

UserListPage.prototype._hideLoadingPopup = function ()
{
    this._loadingPopup.hide();
};

UserListPage.prototype._showInviteSeveralUsersPopup = function(inviteUsersData)
{
    this._hideLoadingPopup();

    SystemSettings.dateFormat = inviteUsersData.userManagementData.dateFormat;

    var self = this,
        inviteUsersLightBox = new APInviteSeveralUsersLightBox().init(inviteUsersData);

    inviteUsersLightBox.setSuccessCallback(
            function(userFieldsArray) {
                if (userFieldsArray.length == 0)
                {
                    return;
                }

                inviteUsersLightBox.disableUserInputWhileSaving();

                var successHandler = function(userManagementResult)
                {
                    inviteUsersLightBox.enableUserInputWhileSaving();

                    inviteUsersLightBox.switchToUsersInvitedState(userManagementResult.usersInfos);

                    self._licenseCounterManager.setLicenseCounter(userManagementResult.licenseCounters);
                    self._licenseCounterManager.update();
                    self.setAddUserButtonStyleAccordingToLicense(userManagementResult.licenseCounters);

                    var noUsersRow = $("#userListTable").find(".actualContent").find(".noUsersRow");
                    var noUsersOnPage = !!noUsersRow.get(0);
                    if (noUsersOnPage)
                        noUsersRow.remove();

                    if (!self._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups))
                        return;

                    var $body = $("body");
                    var scrollTop = $body.scrollTop();
                    for (var i = userManagementResult.usersInfos.length - 1; i > -1; i--)
                    {
                        var userInfo = userManagementResult.usersInfos[i];
                        var newRow = self._createRowAtFirstPosition(userInfo, userManagementResult.userApprovers, false);
                        self._visibleOnPageUserIds.push(userInfo.id);

                        var topSpacer = self._spacer.clone();
                        topSpacer.addClass("apUserListTopSpacer");

                        newRow.next(".apUserListTopSpacer").remove(); //remove spacer from previously added user if there is one
                        newRow.before(topSpacer);

                        if (!noUsersOnPage)
                        {
                            var bottomSpacer = self._spacer.clone();
                            bottomSpacer.addClass("apUserListBottomSpacer");
                            newRow.after(bottomSpacer);
                        }

                        newRow.addClass("apUserListNewUser");
                        $body.scrollTop(scrollTop);
                    }

                    self._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult);
                    PageOverlayTipsManager.getInstance().refreshDynamicTips();
                };

                var exceptionMapExtender = {};
                exceptionMapExtender["com.actimind.actitime.services.InviteSeveralUsersException"] = function(row, errorThrown){
                    inviteUsersLightBox.showServerErrors(errorThrown.userTableErrors);
                    inviteUsersLightBox.enableUserInputWhileSaving();
                    return true;  //prevent from passing to default error handler
                };
                exceptionMapExtender["com.actimind.actitime.administration.UserExistsException"] = function(row, errorThrown){
                    alert(messageResource.getMessage("userlist.js.invite_user_mode_popup.duplicate_username"));
                    inviteUsersLightBox.enableUserInputWhileSaving();
                    return true;  //prevent from passing to default error handler
                };

                var resultHandler = new UserManagementResultHandler(null, function() {}, successHandler, null, exceptionMapExtender);

                makeRpcCall("UserManagementService.inviteUsers", [userFieldsArray], resultHandler.successHandler, resultHandler.errorHandler);
            }
    );
    inviteUsersLightBox.setCancelCallback(
            function()
            {
                inviteUsersLightBox.hide();

                if (!self._updateGroups(inviteUsersData.userManagementData.allUserGroups, inviteUsersData.userManagementData.allTimeZoneGroups))
                {
                    return;
                }
                self._validateIsChangeRightsManageBalanceAndAccountSettings(inviteUsersData.userManagementData);
            });

    inviteUsersLightBox.show();
};

UserListPage.prototype._makeDefaultUserAccountSettings = function ( userManagementData ){

    return {
        firstName: "",
        lastName: "",
        middleInitial: "",
        username: "",
        enabled: true,
        enabledInOtherProduct: true,
        userGroupId: UserManagementConstants.USER_GROUP_NOT_ASSIGNED_ID,
        timeZoneGroupId: UserManagementConstants.DEFAULT_TIME_ZONE_GROUP_ID,
        email:"",
        hireDate: currentUserTime().toJSON(),
        releaseDate: null,
        initialSchedule: userManagementData.defaultWorkSchedule.slice(0),
        defaultInitialSchedule: true,
        workSchedule: []
    };


};

UserListPage.prototype._initAndShowCreateUserPopup = function( userData, userAccountSettings, currentTime, selectedUserId, showOvertime, otherProductStatusEditable)
{
    SystemSettings.dateFormat = userData.userManagementData.dateFormat;

    var sectionBuilderParams = new CommonUserManagementSectionsBuilderParams()
            .setPreparatoryStrategy( new CreateSectionsPreparatoryStrategy().init() )
            .setWorkdayDurationsTableBuilder( new CreateWorkDayDurationsTableBuilder().init( userData.userManagementData ) )
            .setUserManagementData( userData.userManagementData )
            .setCurrentTime( currentTime )
            .setAccountSettings( userAccountSettings )
            .setEditedUserIsLoggedIn(false),
        sectionsBuilder = new ActiplansUserManagementSectionsBuilder().init(sectionBuilderParams),
        self = this,
        createLightBox = new CreateUserLightBox().init( sectionsBuilder,  userData.userManagementData, userAccountSettings,
                                                        userData.allUsers, this._self( this._getCopyUserSettingsData ), selectedUserId,
                                                        this._self( this._abortGetCopyUserSettingsDataRequest ),
                                                        userData.userManagementData.viewerSettings.userGroupsEnabled,
                                                        userData.userManagementData.viewerSettings.timeZoneGroupsEnabled,
                                                        showOvertime, otherProductStatusEditable
        );

    createLightBox.setSuccessCallback(
            function( userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword ) {
                createLightBox.cancelAllServerSideChecks();

                var createUserRequest = function()
                {
                    self._makeCreateUserRequest( createLightBox,  accountSettings, newUserGroupName, newTimeZoneGroup, newPassword );
                };

                if ( isOlVersion )
                {
                    createLightBox.disableUserInputWhileSaving();
                    self.getCurrentTime( accountSettings.timeZoneGroupId,
                                         function( currentTimeInfo )
                                         {
                                             createLightBox.enableUserInputWhileSaving();
                                             var hireDate = accountSettings.hireDate.parseJSONDate();
                                             if( hireDate.getTime() <= currentTimeInfo.currentTime.parseJSONDate().getTime() ) //hire date isn't in future
                                                 createUserRequest();
                                             else
                                             {
                                                 var hireDatePlaceholder = $( "#userDataLightBox_hireDatePlaceholder" );
                                                 scrollToElementInPopup(createLightBox.innerContent, hireDatePlaceholder);
                                                 var invitationDialog = new InvitationDialog().init( $( "#userDataLightBox" ) );
                                                 var formattedHireDate = new DateFormat( SystemSettings.dateFormat ).formatDate( hireDate );
                                                 invitationDialog.setContent( messageResource.getMessage( "userlist.user_popup.confirmation.hire_date", [formattedHireDate] ) );
                                                 invitationDialog.show( hireDatePlaceholder, {offset: "0 7px"}, function ()
                                                 {
                                                     createUserRequest();
                                                     invitationDialog.hideAndRemove();
                                                 } );
                                             }
                                         });
                }
                else
                {
                    createUserRequest();
                }
            }
    );
    createLightBox.setCancelCallback(
            function() {
                createLightBox.cancelAllServerSideChecks();
                createLightBox.hide();
                
                if (!createLightBox.isDataLoaded)
                    return;
                
                if(!self._updateGroups(userData.userManagementData.allUserGroups, userData.userManagementData.allTimeZoneGroups)){
                    return;
                }
                self._validateIsChangeRightsManageBalanceAndAccountSettings(userData.userManagementData);
            });
    createLightBox.show();

    return createLightBox;
};

UserListPage.prototype._showCreateUserPopup = function ( createUserData, targetRow ){

    this._hideLoadingPopup();

    var defaultCreateUserAccountSettings = this._makeDefaultUserAccountSettings( createUserData.userManagementData);
    var createLightBox = this._initAndShowCreateUserPopup(
        createUserData,
        defaultCreateUserAccountSettings,
        createUserData.currentTimeInDefaultTimeZone,
        null,
        false,
        createUserData.showATStatusControl
    )

    createLightBox.scrollToTop();

};

UserListPage.prototype._makeCreateUserRequest = function ( createLightBox,  accountSettings, newUserGroupName, newTimeZoneGroup, newPassword ){

    this._abortGetCopyUserSettingsDataRequest();

    createLightBox.disableUserInputWhileSaving();
    createLightBox.hideSpinner();
    var self = this;

    var exceptionMapExtender = {};
    exceptionMapExtender["com.actimind.common.services.UserEmailInvalidException"] = function()
    {
        createLightBox.handleSectionError( UserManagementConstants.ERROR_EMAIL_INVALID );
        createLightBox.enableUserInputWhileSaving();
        return true;
    };

    exceptionMapExtender["com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException"] = function(row, errorThrown)
    {
        createLightBox.handleDuplicateTimeZoneError(errorThrown.timeZones);
        createLightBox.enableUserInputWhileSaving();
        return true;
    };

    var successHandler = function ( userManagementResult ){
        createLightBox.enableUserInputWhileSaving();

        if ( isOlVersion )
            createLightBox.switchToAccountCreatedState( userManagementResult.invitationSent, function() {
                self._onCreateUserButtonClicked();
            } );
        else
            createLightBox.hide();

        self._licenseCounterManager.setLicenseCounter( userManagementResult.licenseCounters );
        self._licenseCounterManager.update();
        self.setAddUserButtonStyleAccordingToLicense( userManagementResult.licenseCounters );

        var noUsersRow = $("#userListTable" ).find(".actualContent" ).find(".noUsersRow");
        var noUsersOnPage = !!noUsersRow.get(0);
        if ( noUsersOnPage )
            noUsersRow.remove();

        if (!self._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups))
            return;

        var userInfo = userManagementResult.userInfo;
        var newRow = self._createRowAtFirstPosition(  userInfo, userManagementResult.userApprovers, false);

        self._visibleOnPageUserIds.push(userInfo.id);

        var topSpacer = self._spacer.clone();
        topSpacer.addClass("apUserListTopSpacer");

        newRow.next(".apUserListTopSpacer" ).remove(); //remove spacer from previously added user if there is one
        newRow.before( topSpacer );

        if ( !noUsersOnPage ) {
            var bottomSpacer = self._spacer.clone();
            bottomSpacer.addClass("apUserListBottomSpacer");
            newRow.after( bottomSpacer );
        }

        newRow.addClass("apUserListNewUser");

        if (!userManagementResult.userGroups && newUserGroupName) // show new user group name if User Groups was turned off concurrently
        {
            $(newRow).find(".accountTab-userGroupText-div").html(escapeHtmlSymbols(newUserGroupName));
        }

        if (!userManagementResult.timeZoneGroups && newTimeZoneGroup) // show new time zone group name if Time Zone Groups was turned off concurrently
        {
            $(newRow).find(".accountTab-userGroupText-div").html(escapeHtmlSymbols(newTimeZoneGroup.name));
        }

        self._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult);
        PageOverlayTipsManager.getInstance().refreshDynamicTips();
    };

    var resultHandler = new UserManagementResultHandler( null ,function (){}, successHandler, null, exceptionMapExtender );


    function failCallback (jqXHR, textStatus, errorThrown ){
        if (errorThrown.exception == "com.actimind.actitime.administration.UserExistsException")
        {
            alert(messageResource.getMessage("userlist.js.create_user_popup.duplicate_email"));
            createLightBox.enableUserInputWhileSaving();
            return true;
        }
        if (errorThrown.exception != "com.actimind.common.services.UserEmailInvalidException" &&
            errorThrown.exception != "com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException")
        {
            createLightBox.enableUserInputWhileSaving();
            createLightBox.hide();
        }

        return resultHandler.errorHandler(jqXHR, textStatus, errorThrown);
    }
    makeRpcCall(
            "UserManagementService.createUser",
            [accountSettings, newUserGroupName, newTimeZoneGroup, newPassword],
            resultHandler.successHandler, failCallback
    );

};

UserListPage.prototype._showEditUserPopup = function ( editUserData, targetRow ){

    this._hideLoadingPopup();

    SystemSettings.dateFormat = editUserData.userManagementData.dateFormat;

    var editedUserIsLoggedIn = editUserData.userId == this._currentUserId,
        sectionsBuilderParams = new ActiplansUserManagementSectionsBuilderParams().setUserManagementSectionsBuilderParams(
            new CommonUserManagementSectionsBuilderParams()
                    .setPreparatoryStrategy(new EditSectionsPreparatoryStrategy().init(editUserData, editedUserIsLoggedIn))
                    .setWorkdayDurationsTableBuilder(new EditWorkDayDurationsTableBuilder().init( editUserData.userManagementData, editUserData.currentTimeInUserTimeZone))
                    .setUserManagementData(editUserData.userManagementData)
                    .setCurrentTime(editUserData.currentTimeInUserTimeZone)
                    .setUserId(editUserData.userId)
                    .setAccountSettings(editUserData.userAccountSettings)
                    .setEditedUserIsLoggedIn(editedUserIsLoggedIn)
                    .setFirstTTDate(editUserData.firstTTDate)
                    .setFirstRequestDate(editUserData.firstLeaveRequestDate)
        ),
        sectionsBuilder = new ActiplansUserManagementSectionsBuilder().init(sectionsBuilderParams ),
        record = targetRow.data().record,
        userInfo = {
            id: editUserData.userId,
            firstName: record.firstName,
            lastName: record.lastName,
            middleInitial: record.middleInitial
        },
        lb = new EditUserLightBox().init(sectionsBuilder, editUserData.userManagementData, editUserData.userAccountSettings, userInfo, editUserData.hasTimeTrack,
                                         editUserData.lastOtherProductAdmin, false, editUserData.otherProductStatusEditable, editUserData.lastLoginTime, function(){self.removeRow(editUserData.userId)} ),
        self = this;

    lb.setSuccessCallback(
            function( userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword ) {
                lb.cancelAllServerSideChecks();
                self._makeUpdateUserRequest( lb, userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword, targetRow, editUserData.userAccountSettings.timeZoneGroupId, false );
            }
    );
    lb.setDeleteCallback(
            function(userId) {
                lb.cancelAllServerSideChecks();
                self._makeDeleteUserRequest( lb, userId, targetRow, false, false );
            }
    );
    lb.setCancelCallback(
            function() {
              lb.cancelAllServerSideChecks();
              lb.hide();

              if(!self._updateGroups(editUserData.userManagementData.allUserGroups, editUserData.userManagementData.allTimeZoneGroups)){
                  return;
              }
              self._validateIsChangeRightsManageBalanceAndAccountSettings(editUserData.userManagementData);
            });
    lb.show();
    lb.scrollToTop();

};
UserListPage.prototype._makeDeleteUserRequest = function( editLightBox, userId, targetRow, forceChanges, setAllUsersAutoApprovedOnSuccess ){
    editLightBox.setDeleteButtonEnabled(false);
    editLightBox.disableButtons();

    var self = this;

    var exceptionMapExtender = {};

    exceptionMapExtender["com.actimind.actitime.services.NoRightsForRemoteCallException"] = function(){
        alert( messageResource.getMessage( "actiplans.user_list.noRightsForUserAccount" ) );
        document.location.reload();
        return true;  //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.actitime.administration.NoSuchUserException"] = function(){
        UserListPage.removeRow( targetRow );
        return true;  //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.actitime.administration.UserCannotBeDeletedException"] = function(){
        alert(messageResource.getMessage('userlist.js.error_cant_delete'));
        return true;    //prevent from passing to default error handler
    };

    var confirmationIsNeededExceptionFunction = function(row, errorThrown){
        if ( confirm( self._createDeleteConfirmationMsg( errorThrown ) ) )
        {
            var setAllUsersAutoApprovedOnSuccess = false; // errorThrown.confirmationCodes contains LAST_MANAGER_ ...

            /*if ( confirmationCode == UserListPageConstants.CONFIRMATION_IS_NEEDED_ON_DELETE_DUE_TO_LAST_LTM ||
                 confirmationCode == UserListPageConstants.CONFIRMATION_IS_NEEDED_ON_DELETE_DUE_TO_LAST_LTM_AND_LEAVE_REQUESTS )
            {
                setAllUsersAutoApprovedOnSuccess = true;
            }*/
            self._makeDeleteUserRequest( editLightBox, userId, targetRow, true, setAllUsersAutoApprovedOnSuccess );
        }
        return true;    //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.common.administration.EditUserConfirmationIsNeededException"] = confirmationIsNeededExceptionFunction;
    exceptionMapExtender["com.actimind.common.administration.DeleteUserConfirmationIsNeededException"] = confirmationIsNeededExceptionFunction;

    var successHandler = function ( userManagementResult ){
        editLightBox.enableUserInputWhileSaving();
        editLightBox.hide();
        self._licenseCounterManager.setLicenseCounter( userManagementResult.licenseCounters );
        self._licenseCounterManager.update();
        self.setAddUserButtonStyleAccordingToLicense( userManagementResult.licenseCounters );

        UserListPage.removeRow( targetRow );

        $(".actualContent tr.apUserListBottomSpacer:last-child" ).remove();

        // remove userId from array of visible users
        self._visibleOnPageUserIds.splice( $.inArray(userId, self._visibleOnPageUserIds), 1 );

        if(!self._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups)){
            return;
        }
        if(self._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult)){
            return;
        }

        if ( setAllUsersAutoApprovedOnSuccess )
            self._setAllUsersAutoApproved();

        // 1 as userRow is in templateRow
        if( self._userListBody.find( ".userRow" ).size() == 1 )
        {
            self._pagerController.reloadEmptyPage();
        }
    };

    var resultHandler = new UserManagementResultHandler( null , function (){}, successHandler, null, exceptionMapExtender );

    function errorHandler ( jqXHR, textStatus, errorThrown ){
        editLightBox.enableUserInputWhileSaving();
        editLightBox.hide();
        return resultHandler.errorHandler( jqXHR, textStatus, errorThrown );
    }

    makeRpcCall(
            "UserManagementService.deleteUser",
            [ userId, forceChanges ],
            resultHandler.successHandler, errorHandler
    );

};

UserListPage.prototype._updateGroups = function(userGroups, timeZoneGroups)
{
    var userGroupsEnabled = userGroups ? true : false;
    var timeZoneGroupsEnabled = timeZoneGroups ? true : false;
    if (this._isUGREnabled() != userGroupsEnabled) {
        this._onUGRChanged( true );
        return false;
    }
    if (this._isTZGEnabled() != timeZoneGroupsEnabled) {
        this._onTZGChanged(true);
        return false;
    }
    var state = this._stateController.getState();
    if ((this._isUGREnabled() && userGroupsEnabled) || (this._isTZGEnabled() && timeZoneGroupsEnabled))
    {
        this._allUserGroups = userGroups;
        this._userGroupIdToGroupMap = makeMapForEntitiesArray(userGroups ? userGroups : []);
        this._allTimeZoneGroups = timeZoneGroups;
        this._timeZoneGroupIdToGroupMap = makeMapForEntitiesArray(timeZoneGroups ? timeZoneGroups : []);
        this._userGroupsSelector.getPanel().updateGroupsData(
                this._isUGREnabled() ?
                    this._getGroupWrappersList(this._allUserGroups, this._userGroupIdToGroupMap, state.userListFilter.groupIds, true, SystemSettings.usersWithoutGroupId) :
                    null,
                this._isTZGEnabled() ?
                    this._getGroupWrappersList(this._allTimeZoneGroups, this._timeZoneGroupIdToGroupMap, state.userListFilter.groupIds, false, DEFAULT_TIME_ZONE_GROUP_ID) :
                    null
        );
        this._updateGroupInAllRows();
    }
    return true;
};

UserListPage.prototype._updateApproverName = function ( userInfo )
{
    var self = this;
    var updatedUserApprover = {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        middleInitial: userInfo.middleInitial,
        userName: userInfo.name,
        id: userInfo.id
    };

    $.each(this._userListBody.find(".userRow"),
           function (index, row){
               var userApprovers = $(row).data().userApprovers;
               if ( userApprovers != null )
               {
                   for( var i = 0; i < userApprovers.length; i++ )
                   {
                       if ( userInfo.id == userApprovers[i].id )
                       {
                           userApprovers[i] = updatedUserApprover;
                           self._updateApprovedByCellContent( $(row) );
                           break;
                       }
                   }
               }
           }
    );
};

UserListPage.prototype._setAllUsersAutoApproved = function ()
{
    var self = this;

    $.each(this._userListBody.find(".userRow"),
           function (index, row){
               var record =  $(row).data().record;

               if ( record.requiresApproval )
               {
                   record.requiresApproval = false;
                   self._updateApprovedByCellContent( $(row) );
               }

               if ( record.roles.allowedToManageRequests && record.enabled )
               {
                   record.roles.allowedToManageRequests = false;
                   self._updateManageRequestsRoleAndUsersForApproverCellContent( $(row) );
               }
           }
    );
    
    PageOverlayTipsManager.getInstance().refreshDynamicTips();
};

UserListPage.prototype._highlightRow = function( targetRow ) {
    $( targetRow ).addClass("apUserListUpdatedUser");
    setTimeout( function() {
        $( targetRow ).removeClass('apUserListUpdatedUser');
    }, 1500);
};

UserListPage.prototype._makeUpdateUserRequest = function( editLightBox, userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword, targetRow, previousTimeGroupZoneId, forceChanges )
{
    editLightBox.disableUserInputWhileSaving();
    var self = this;

    var exceptionMapExtender = {};
    exceptionMapExtender["com.actimind.actitime.administration.UserExistsException"] = function(){
            editLightBox.handleSectionError( UserManagementConstants.ERROR_DUPLICATE_USERNAME );
            editLightBox.enableUserInputWhileSaving();
            return true;  //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.actitime.administration.NoSuchUserException"] = function(){
        alert(messageResource.getMessage('actiplans.user_list.error_user_was_deleted'));
        UserListPage.removeRow( targetRow );
        return true;  //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.common.administration.LastManagerInOtherProductException"] = function(){
        alert(messageResource.getMessage('user.edit.js.cannot_disable.last_admin_ap'));
        return true;    //prevent from passing to default error handler
    };

    var confirmationIsNeededExceptionFunction = function( row, errorThrown ){
        if ( confirm( self._createEditConfirmationMsg( errorThrown ) ) )
            self._makeUpdateUserRequest( editLightBox, userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword, targetRow, previousTimeGroupZoneId, true );
        else
            editLightBox.enableUserInputWhileSaving();
        return true;  //prevent from passing to default error handler
    };

    exceptionMapExtender["com.actimind.common.administration.EditUserConfirmationIsNeededException"] = confirmationIsNeededExceptionFunction;
    exceptionMapExtender["com.actimind.common.administration.DeleteUserConfirmationIsNeededException"] = confirmationIsNeededExceptionFunction;

    exceptionMapExtender["com.actimind.common.services.UserEmailInvalidException"] = function()
    {
        editLightBox.handleSectionError( UserManagementConstants.ERROR_EMAIL_INVALID );
        editLightBox.enableUserInputWhileSaving();
        return true;
    };

    exceptionMapExtender["com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException"] = function(row, errorThrown)
    {
        editLightBox.handleDuplicateTimeZoneError(errorThrown.timeZones);
        editLightBox.enableUserInputWhileSaving();
        return true;
    };

    var successHandler = function ( userManagementResult ){
        editLightBox.enableUserInputWhileSaving();
        editLightBox.hide();

        // update user list if time zone has been changed
        if ( ( userManagementResult.userInfo.id == self._currentUserId ) &&
             previousTimeGroupZoneId != userManagementResult.userInfo.timeZoneGroupId )
        {
            self._abortAllRequests();
            alert(messageResource.getMessage('actiplans.user_list.message.time_zone_was_changed'));
            document.location.reload();
            return;
        }

        self._licenseCounterManager.setLicenseCounter( userManagementResult.licenseCounters );
        self._licenseCounterManager.update();
        self.setAddUserButtonStyleAccordingToLicense( userManagementResult.licenseCounters );

        self._highlightRow(targetRow);

        if(!self._updateGroups(userManagementResult.userGroups, userManagementResult.timeZoneGroups)){
            return;
        }
        if(self._validateIsChangeRightsManageBalanceAndAccountSettings(userManagementResult)){
            return;
        }

        self._updateApproverName( userManagementResult.userInfo );

        if ( forceChanges )
            self._setAllUsersAutoApproved();
    };
    var resultHandler = new UserManagementResultHandler( $( targetRow ) , this._self(this._updateRowAndTips), successHandler, null, exceptionMapExtender );

    function failCallback (jqXHR, textStatus, errorThrown ){
        if( errorThrown.exception !="com.actimind.actitime.administration.UserExistsException" &&
            errorThrown.exception !="com.actimind.common.administration.EditUserConfirmationIsNeededException" &&
            errorThrown.exception !="com.actimind.common.administration.DeleteUserConfirmationIsNeededException" &&
            errorThrown.exception != "com.actimind.common.services.UserEmailInvalidException" &&
            errorThrown.exception != "com.actimind.actitime.administration.DuplicateTimeZoneGroupNameException")
        {
            editLightBox.enableUserInputWhileSaving();
            editLightBox.hide();
        }

        return resultHandler.errorHandler(jqXHR, textStatus, errorThrown);
    }

    makeRpcCall(
            "UserManagementService.updateUser",
            [userId, accountSettings, newUserGroupName, newTimeZoneGroup, newPassword, forceChanges],
                resultHandler.successHandler, function(jqXHR, textStatus, errorThrown){return failCallback(jqXHR, textStatus, errorThrown )}
    );

};

UserListPage.prototype._abortGetInviteSeveralUsersDataRequest = function ()
{
    if (this._getInviteSeveralUsersDataRequestObject)
    {
        this._getInviteSeveralUsersDataRequestObject.abort();
    }
};

UserListPage.prototype._onInviteSeveralUsersButtonClicked = function ()
{
    this._abortAllRequests();
    this._showLoadingPopup();
    var self = this;
    this._getInviteSeveralUsersDataRequestObject = makeRpcCall("UserManagementService.getInviteUsersData", [],
                                                               function(inviteUsersData)
                                                               {
                                                                   self._showInviteSeveralUsersPopup(inviteUsersData);
                                                               },
                                                               function(jqXHR, textStatus, errorThrown)
                                                               {
                                                                   self._hideLoadingPopup();

                                                                   if (errorThrown.exception == 'com.actimind.actitime.services.NoRightsToManageAccountSettings')
                                                                   {
                                                                       alert(messageResource.getMessage('actiplans.user_list.error_cant_create_user_account'));
                                                                       document.location.reload();
                                                                       return true;
                                                                   }
                                                                   return false;
                                                               }
    );

};

UserListPage.prototype._abortGetCreateUserDataRequest = function ()
{
    if( this._getCreateUserDataRequestObject )
    {
        this._getCreateUserDataRequestObject.abort();
    }
};

UserListPage.prototype._onCreateUserButtonClicked = function ( jQueryEvent ){
    this._abortAllRequests();
    this._showLoadingPopup();
    var self = this;
    this._getCreateUserDataRequestObject = makeRpcCall( "UserManagementService.getCreateUserData", [],
                 function( createUserData )
                 {
                     self._showCreateUserPopup( createUserData );
                 },
                 function ( jqXHR, textStatus, errorThrown )
                 {
                     self._hideLoadingPopup();

                     if( errorThrown.exception == 'com.actimind.actitime.services.NoRightsToManageAccountSettings' )
                     {
                         alert( messageResource.getMessage( 'actiplans.user_list.error_cant_create_user_account' ) );
                         document.location.reload();
                         return true;
                     }
                     return false;
                 }
    );

};

UserListPage.prototype._getCopyUserSettingsData = function ( createUserLightBox, userId )
{
    this._abortGetCopyUserSettingsDataRequest();

    var self = this;
    this._getCopyUserSettingsDataRequestObject = makeRpcCall( "UserManagementService.getCopyUserSettingsData", [userId],
                                                             function( copyUserSettingsData )
                                                             {
                                                                 var createUserLightBoxState = createUserLightBox.getLightBoxState();
                                                                 createUserLightBox.hide();

                                                                 self._processCopyUserSettingsData( copyUserSettingsData, createUserLightBoxState.userInputData,
                                                                                                    createUserLightBoxState.errorState, createUserLightBoxState.scrollPosition );
                                                             },
                                                             function ( jqXHR, textStatus, errorThrown )
                                                             {
                                                                 createUserLightBox.hideSpinner();
                                                                 if( errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException' )
                                                                 {
                                                                     alert( messageResource.getMessage( 'actiplans.user_list.error_user_was_deleted' ) );
                                                                     usersSelector.removeUser( userId );
                                                                     return true;
                                                                 }
                                                                 if( errorThrown.exception == 'com.actimind.actitime.services.NoRightsToManageAccountSettings' )
                                                                 {
                                                                     alert( messageResource.getMessage( 'actiplans.user_list.error_cant_create_user_account' ) );
                                                                     document.location.reload();
                                                                     return true;
                                                                 }
                                                                 usersSelector.enableInput();
                                                                 usersSelector.rollbackSelection();
                                                                 return false;
                                                             }

    );
};

UserListPage.prototype._abortGetCopyUserSettingsDataRequest = function ()
{
    if ( this._getCopyUserSettingsDataRequestObject )
    {
        this._getCopyUserSettingsDataRequestObject.abort();
        this._getCopyUserSettingsDataRequestObject = null;
    }
};

UserListPage.prototype._processCopyUserSettingsData = function ( copyUserSettingsData, userInputData, errorState, scrollPosition )
{
    copyUserSettingsData.userAccountSettings.firstName = userInputData.firstName;
    copyUserSettingsData.userAccountSettings.lastName = userInputData.lastName;
    copyUserSettingsData.userAccountSettings.middleInitial = userInputData.middleInitial;
    copyUserSettingsData.userAccountSettings.username = userInputData.username;
    copyUserSettingsData.userAccountSettings.enabled = userInputData.enabled;
    copyUserSettingsData.userAccountSettings.enabledInOtherProduct = userInputData.enabledInOtherProduct;
    copyUserSettingsData.userAccountSettings.email = userInputData.email;
    copyUserSettingsData.userAccountSettings.releaseDate = userInputData.releaseDate;
    copyUserSettingsData.userAccountSettings.hireDate = userInputData.hireDate;
    copyUserSettingsData.userAccountSettings.passwordData = userInputData.passwordData;

    var lb = this._initAndShowCreateUserPopup( copyUserSettingsData, copyUserSettingsData.userAccountSettings,
                                        copyUserSettingsData.currentTimeInUserTimeZone, copyUserSettingsData.userId, true );

    lb.restoreState( errorState, scrollPosition );
};

UserListPage.prototype._onBalanceClicked = function ( jQueryEvent, balanceType ){
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var record = row.data().record;
    var balanceData;
    let titleKey = ""
    if ( balanceType === BalanceType.PTO ) {
        balanceData = record.ptoData;
        titleKey = 'common.pto_editor.title'
    }
    if ( balanceType === BalanceType.SICK ) {
        balanceData = record.sickDaysData;
        titleKey = 'common.sick_editor.title'
    }

    if( balanceData && !balanceData.notStarted )
    {
        this._abortRequestsBeforeUserSettingsUpdate( UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_BALANCE );

        var userName = UserNameFormat.formatFML( record.firstName, record.lastName, record.middleInitial );

        this._balanceEditor.setOnCloseCallback( function() {
            row.removeClass("selected");
        });

        this._balanceEditor.show( cell, balanceData.balance, userName, this._ptoHoursPerDay, balanceType, titleKey );
        this._balanceEditor.setOnApplyCallback( this._self( function( correctionType, valueInDays, comment ) {
            this._callUserManagementService( row, "UserManagementService.addBalanceCorrection",
                                             [record.id, balanceType, correctionType, valueInDays, comment],
                                             UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_BALANCE,
                                             null,
                                             function() {
                                                 this._balanceEditor.hide();
                                                 this._highlightRow(row);
                                             },
                                             function( jqXHR, textStatus, errorThrown ) {
                                                 this._balanceEditor.busyModeOff();
                                                 if( errorThrown.exception == 'com.actimind.actitime.administration.NoSuchUserException' )
                                                 {
                                                     this._balanceEditor.hide();
                                                 }
                                                 else if( errorThrown.exception == 'com.actimind.common.balance.BalanceCapExceededException' )
                                                 {
                                                     this._balanceEditor.showCapExceededError( errorThrown.cap );
                                                     return true;
                                                 }
                                                 return false;
                                             }
            )
        }));

        row.addClass("selected");
    }
};

UserListPage.prototype._sendSetUserAutoApprovedRequest = function ( row, id, requiresApproval, forceChanges ){
    var self = this;
    this._callUserManagementService(row, 'UserManagementService.setUserAutoApproved',
                                    [id, requiresApproval, forceChanges],
                                    UserListPage.USER_SETTINGS_UPDATE_KEY_APPROVED_BY, "spinnerPlaceholder",
                                    null,
                                    forceChanges ? null : function( jqXHR, textStatus, errorThrown ) {
                                        if( errorThrown.exception == 'com.actimind.actiplans.administration.WaitingForApprovalRequestsExistException' )
                                        {
                                            if( confirm( messageResource.getMessage( "actiplans.user_list.js.auto_approved_confirmation" ) ) )
                                            {
                                                self._sendSetUserAutoApprovedRequest( row, id, requiresApproval, true );
                                            }
                                            return true;
                                        }
                                        if( errorThrown.exception == 'com.actimind.actiplans.administration.NoLeaveTimeManagerException' )
                                        {
                                            alert( messageResource.getMessage ("actiplans.user_list.js.set_auto_approved.no_leave_request_managers" ) );
                                            self._setAllUsersAutoApproved();
                                            return true;
                                        }
                                        return false;
                                    }
    );
};

UserListPage.prototype._addAccrualRulesHoveredState = function ( jQueryEvent, balanceType ){
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var record = cell.parents('tr').data().record;

    if( (!record.ptoData && balanceType == BalanceType.PTO) || (!record.sickDaysData && balanceType == BalanceType.SICK) )
        return;

    row.find(".accrueRule-td" ).addClass("hovered");
    row.find(".resetRule-td" ).addClass("hovered");
    row.find(".capRule-td" ).addClass("hovered");
};

UserListPage.prototype._removeAccrualRulesHoveredState = function ( jQueryEvent ){
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');

    row.find(".accrueRule-td" ).removeClass("hovered");
    row.find(".resetRule-td" ).removeClass("hovered");
    row.find(".capRule-td" ).removeClass("hovered");
};


UserListPage.prototype._showUserWorkScheduleTooltip = function ( jQueryEvent, offset ){
    var cell = $( jQueryEvent.delegateTarget );
    var row = cell.parents('tr');
    var record = row.data().record;

    var scheduleHeaderText = record.defaultWorkSchedule ? messageResource.getMessage("actiplans.user_list.js.tooltip.corporateSchedule") :
                                                          messageResource.getMessage("actiplans.user_list.js.tooltip.personalSchedule") ;
    var weekText =  "<span class='week duration'> " + UserTime.formatTime( record.workingWeekTotal ) +"h"+ "</span>";

    this._tablePlaceholder.html( "" );
    var workdayDurationViewer = new WorkdayDurationsViewer().init( record.effectiveSchedule, this._weekStartDay, function () {}, true, "" );
    workdayDurationViewer.renderTo( this._tablePlaceholder[0] );

    this._scheduleHeader.html( scheduleHeaderText );
    this._weekTextPlaceholder.html( weekText );

    this._userWorkScheduleTooltip.show();
    if( offset )
        this._userWorkScheduleTooltip.offset( offset );
};

UserListPage.prototype._showApproversTooltip = function ( jQueryEvent, offset )
{
    var cell = $( jQueryEvent.delegateTarget );
    var userRowData = cell.parents( 'tr' ).data();

    this._approversTooltip.updateUIAndShow( {
                                                requiresApproval: userRowData.record.requiresApproval,
                                                userIsManager: userRowData.record.roles.allowedToManageRequests,
                                                userApprovers: userRowData.userApprovers
                                            },
                                            offset );
};

UserListPage.prototype._verifyCanAssignUsersToApprover = function( record ) {
    return this._viewerSettings.allowedToManageAccountSettings && record.enabled && record.roles.allowedToManageRequests;
}

UserListPage.prototype._showUsersForApproverTooltip = function ( jQueryEvent, offset ) {
    var cell = $(jQueryEvent.delegateTarget);
    var record = cell.parents('tr').data().record;

    if ( !this._verifyCanAssignUsersToApprover(record) )
        return;

    this._usersForApproverTooltip.show();
    if( offset )
        this._usersForApproverTooltip.offset( offset );
};

UserListPage.prototype._showAccrualRulesTooltip = function ( jQueryEvent, balanceRulesManager, data ){
    var cell = $(jQueryEvent.delegateTarget);
    var record = cell.parents('tr').data().record;
    var tooltipData = record[data];
    if(tooltipData){
        tooltipData.hireDate = record.hireDate;
    }
    balanceRulesManager.showAccrualRulesTooltip(jQueryEvent, tooltipData);
};

UserListPage.prototype._onEditRulesClicked = function ( jQueryEvent, balanceType ){
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var record = cell.parents('tr').data().record;

    var balanceData = balanceType == BalanceType.PTO ? record.ptoData : record.sickDaysData;
    var balanceRulesManager = balanceType == BalanceType.PTO ? this.ptoRulesManager : this.sickRulesManager;
    if( !balanceData )
         return;

    balanceRulesManager.hideAccrualRulesTooltip();
    balanceRulesManager.updateDialog(balanceData);

    var that = this;

    this._abortRequestsBeforeUserSettingsUpdate( UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_RULES );

    balanceRulesManager.setModifyBalanceAccrualRulesOkClick(function() {
        that._modifyBalanceAccrualRulesOkClick(cell, row, record, balanceType);
        that._highlightRow(row);
    });
    balanceRulesManager.setOnCloseCallback( function() {
        row.removeClass("selected ptoDialogSelected");
    });

    balanceRulesManager.showDialogAt(balanceData.defaultRules ? row.find(".accrueRule-td:visible") : row.find(".resetRule-td:visible"), {offset: "5px -10px"});

    row.addClass("selected ptoDialogSelected");
};

UserListPage.prototype._onShowSickBalanceHistoryClicked = function(jQueryEvent){
    this._balanceHistoryPanel.updateTitle(messageResource.getMessage("common.balance_history.balance_history_panel.title", [messageResource.getMessage("common.balance_history.table.sick")]));

    var config = {};
    config.balanceHistoryService ='UserManagementService.getUserSickBalanceHistory';
    config.prefix = BalanceHistory.BalanceTypes.SICK;
    config.showBalanceInHours = SystemSettings.showSickInHours;
    config.balanceType = BalanceType.SICK;
    this._onShowBalanceHistoryClicked(jQueryEvent, config, BalanceType.SICK);
};

UserListPage.prototype._onShowPtoBalanceHistoryClicked = function(jQueryEvent){
    this._balanceHistoryPanel.updateTitle(messageResource.getMessage("common.balance_history.balance_history_panel.title", [messageResource.getMessage("common.balance_history.table.pto")]));

    var config = {};
    config.balanceHistoryService ='UserManagementService.getUserPtoBalanceHistory';
    config.prefix = BalanceHistory.BalanceTypes.PTO;
    config.balanceType = BalanceType.PTO;
    config.showBalanceInHours = SystemSettings.showPTOInHours;
    this._onShowBalanceHistoryClicked(jQueryEvent, config, BalanceType.PTO);
};

UserListPage.prototype._onShowBalanceHistoryClicked = function ( jQueryEvent, config, balanceType ) {
    var cell = $(jQueryEvent.delegateTarget);
    var row = cell.parents('tr');
    var record = cell.parents('tr').data().record;

    if( (balanceType == BalanceType.PTO && !record.ptoData) || (balanceType == BalanceType.SICK && !record.sickDaysData) )
        return;

    var that = this;

    this.addRowSelection(row);
    this.showLoadingHistoryProgress(cell);

    makeRpcCall(    config.balanceHistoryService,
                    [record.id],
                    function (extendedUserPtoBalanceHistoryData) {
                        new PanelBalanceHistoryTable(that.$tableContainerEl, extendedUserPtoBalanceHistoryData.userBalanceHistoryRecords.list, that._ptoHoursPerDay, config.showBalanceInHours,  config.prefix).init();
                        that._balanceHistoryPanel.setOnCloseCallback( function () {  cell.removeClass("dialogSelected"); that.clearRowSelection(row); } );
                        that._balanceHistoryPanel.updateLinkState(extendedUserPtoBalanceHistoryData.userBalanceHistoryRecords.list.length, record.id, config.balanceType);
                        that._balanceHistoryPanel.showAt(row.find(".balanceHistoryShow-td:visible"));
                        row.find(".balanceHistoryShow-td" ).removeClass("hovered");
                        that.hideLoadingHistoryProgress(cell);
                        cell.addClass("dialogSelected");
                    },
                    function ( jqXHR, textStatus, errorThrown ) {
                        that.clearRowSelection(row);
                        that.hideLoadingHistoryProgress(cell);
                        if (errorThrown.exception == "com.actimind.actitime.administration.NoSuchUserException")
                        {
                            alert( messageResource.getMessage( 'actiplans.user_list.error_user_was_deleted.short' ) );
                            UserListPage.removeRow( row );
                            return true;
                        }
                    }
                );
};

UserListPage.prototype.addRowSelection = function (row) {
    row.addClass("selected");
};
UserListPage.prototype.clearRowSelection = function (row) {
    row.removeClass("selected");
};
UserListPage.prototype.showLoadingHistoryProgress = function ( cell ) {
    cell.find("img" ).hide();
    cell.addClass("loading");
    this._spinnerController.spinInElement(cell.find(".ptoHistorySpinnerPlaceholder"));
};

UserListPage.prototype.hideLoadingHistoryProgress = function ( cell ) {
    cell.find("img" ).show();
    cell.removeClass("loading");
    this._spinnerController.stop();
};

UserListPage.prototype._modifyBalanceAccrualRulesOkClick = function(cell, row, record, balanceType) {
    var balanceRulesManager = balanceType == BalanceType.PTO ? this.ptoRulesManager : this.sickRulesManager;
    var dialogValues = balanceRulesManager.getDialogValues();
    this._callUserManagementService(row, 'UserManagementService.setBalanceRules',
                                    [record.id, balanceType, dialogValues.useDefaults, dialogValues.accrualRule, dialogValues.resetRule, dialogValues.capRule],
                                    UserListPage.USER_SETTINGS_UPDATE_KEY_PTO_RULES,
                                    null,
                                    function() {
                                        balanceRulesManager.hideDialog();
                                    },
                                    function() {
                                        balanceRulesManager.hideDialog();
                                    }
    );
};

UserListPage.prototype._abortUserSettingsUpdateRequests = function ()
{
    for( var key in this._userSettingsUpdateRequestObjects )
    {
        if( this._userSettingsUpdateRequestObjects.hasOwnProperty( key ) )
        {
            this._userSettingsUpdateRequestObjects[key].abort();
            delete this._userSettingsUpdateRequestObjects[key];
        }
    }
};

UserListPage.prototype._abortAllRequests = function ()
{
    this._abortUserListUpdateRequest( false );
    this._abortUserSettingsUpdateRequests();

    this._abortGetCreateUserDataRequest();
    this._abortGetEditUserDataRequest();
    this._abortGetInviteSeveralUsersDataRequest();
};

UserListPage.prototype._abortRequestsBeforeUserListUpdate = function ()
{
    this._abortUserListUpdateRequest( true );
    this._abortUserSettingsUpdateRequests();

    this._abortGetCreateUserDataRequest();
    this._abortGetEditUserDataRequest();
    this._abortGetInviteSeveralUsersDataRequest();
};

UserListPage.prototype._abortRequestsBeforeUserSettingsUpdate = function ( userSettingKey )
{
    this._abortUserListUpdateRequest( false );
    if( this._userSettingsUpdateRequestObjects[userSettingKey] )
    {
        this._userSettingsUpdateRequestObjects[userSettingKey].abort();
        delete this._userSettingsUpdateRequestObjects[userSettingKey];
    }

    this._abortGetCreateUserDataRequest();
    this._abortGetEditUserDataRequest();
    this._abortGetInviteSeveralUsersDataRequest();
};

UserListPage.prototype._onSortButtonClick = function ( sortBy, spinnerContainerId )
{
    var state = this._stateController.getProperties( ['sortBy', 'isAscending', 'pageNum'] );
    if( state.sortBy == sortBy )
    {
        state.isAscending = !state.isAscending;
    }
    else
    {
        state.sortBy = sortBy;
        state.isAscending = true;
    }
    state.pageNum = 1;
    this._stateController.setProperties( state );

    this._updateUserList( spinnerContainerId, true );
};

UserListPage.prototype._abortUserListUpdateRequest = function ( isBeforeUserListUpdate )
{
    if( this._updateUserListDelayTimer != null )
    {
        clearTimeout( this._updateUserListDelayTimer );
        this._updateUserListDelayTimer = null;
        if( !isBeforeUserListUpdate )
            this._stateController.loadState();
    }

    if( this._userListUpdateRequestObject != null )
        if( isBeforeUserListUpdate )
            this._userListUpdateRequestObject.abort( 'abortBeforeUserListUpdate' );
        else
            this._userListUpdateRequestObject.abort();
};

UserListPage.prototype._updateUserListWithDelay = function ( delay, spinnerContainerId )
{
    this._abortRequestsBeforeUserListUpdate();
    var that = this;
    // Note: if timer will be stopped, then it must be set to null
    this._updateUserListDelayTimer = setTimeout( function ()
                                                 {
                                                     that._updateUserList( spinnerContainerId, true );
                                                     that._updateUserListDelayTimer = null;
                                                 }, delay );
};

UserListPage.prototype._updateUserList = function ( spinnerContainerId, showAlertOnReload )
{
    this._abortRequestsBeforeUserListUpdate();

    var that = this;
    this._userListUpdateRequestObject = makeRpcCall(
            "UserManagementService.getUsers",
            [
                this._stateController.getProperty("userListFilter"),
                this._getSearchUsersTokens(),
                this._stateController.getProperty("sortBy"),
                this._stateController.getProperty("isAscending"),
                this._stateController.getProperty("pageNum"),
                this._stateController.getProperty("recordsPerPage")
            ],
            function ( pageData )
            {
                that._spinnerController.stop();

                that._updatePage( pageData, showAlertOnReload );
                that._stateController.saveState();
                that._checkIfSelectedGroupWasDeleted();
                $(".apUserListBottomSpacer" ).remove();
                $(".apUserListTopSpacer" ).remove();

            },
            function ( jqXHR, textStatus, errorThrown )
            {
                that._spinnerController.stop();

                if( textStatus == 'abortBeforeUserListUpdate' )
                {
                    return true;
                }
                else
                {
                    that._stateController.loadState();
                }
            }
    );
    this._spinnerController.spin( spinnerContainerId );
};

UserListPage.prototype._getSearchUsersTokens = function ()
{
    return new StringTokenizer( StringTokenizer.PUNCTUATORS_FOR_SEARCH ).getTokens( this._stateController.getProperty( 'userNameFilterText' ).toLowerCase() );
};

UserListPage.prototype._getUserNameTokensHighlighter = function ()
{
    var tokens = this._getSearchUsersTokens();
    return (tokens && tokens.length > 0) ? new TokensHighlighter( tokens, StringTokenizer.PUNCTUATORS_FOR_SEARCH ) : new EmptyHighlighter();
};

UserListPage.prototype._createWarningMsgs = function(userInfo, isCreatingUser )
{
    var warnings = userInfo.warnings;
    if ( !warnings )
        return {};

    var warningMsgs = [];
    var infoMsgs = [];

    var fullName = UserNameFormat.formatFML(
            userInfo.firstName ,
            userInfo.lastName,
            userInfo.middleInitial
    );

    for( var i = 0; i < warnings.length; i++ )
    {
        var warningCode = warnings[i];

        if( warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS ||
            warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_LICENSE_TERMS ||
            warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_BOTH_PRODUCTS_DUE_TO_LICENSE_TERMS ){

            var key = warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_LICENSE_TERMS ?
                      "userlist.js.warning_account_disabled_due_to_license_terms_ap" :
                      warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_LICENSE_TERMS ?
                        "userlist.js.warning_account_disabled_due_to_license_terms_at" :
                        "userlist.js.warning_account_disabled_due_to_license_terms_both_products";

            var messagePart1 = messageResource.getEscapedMessage(key, [fullName]);
            var messagePart2 = messageResource.getEscapedMessage("userlist.js.warning_account_disabled_due_to_license_terms_info",[fullName]);
            warningMsgs.push(messagePart1 + "<p class='sameMsgNewParagraph'>"+messagePart2+"</p>");
        }
        else if( warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_DUE_TO_FUTURE_HIRE_DATE){
            var formattedHireDate = new DateFormat(SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_ap",[formattedHireDate]));
        }
        else if( warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_OTHER_PRODUCT_DUE_TO_FUTURE_HIRE_DATE){
            var formattedHireDate = new DateFormat(SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_at",[formattedHireDate]));
        }
        else if( warningCode == UserListPageConstants.WARNING_ACCOUNT_DISABLED_IN_BOTH_PRODUCTS_DUE_TO_FUTURE_HIRE_DATE){
            var formattedHireDate = new DateFormat(SystemSettings.dateFormat).formatDate(userInfo.hireDate.parseJSONDate());
            infoMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_account_disabled_due_to_future_hire_date_both_products",[formattedHireDate]));
        }
        else if( warningCode == UserListPageConstants.WARNING_USER_GROUP_NO_LONGER_EXISTS ){
            warningMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_user_group_no_longer_exists",[fullName]));
        }
        else if( warningCode == UserListPageConstants.WARNING_TIME_ZONE_GROUP_NO_LONGER_EXISTS ){
            warningMsgs.push(messageResource.getEscapedMessage("userlist.js.warning_time_zone_group_no_longer_exists",[fullName]));
        }
        else if( warningCode == UserListPageConstants.WARNING_NO_RIGHT_TO_EDIT_STATUS_IN_OTHER_PRODUCT ){
            warningMsgs.push(messageResource.getEscapedMessage(
                    isCreatingUser ?
                        "userlist.js.warning_no_right_to_edit_status_in_at.creating" :
                        "userlist.js.warning_no_right_to_edit_status_in_at.editing" ));
        }
        else
            throw "Unknown warning code has been received from the server: "+warningCode;
    }

    return { warningMsgs: warningMsgs, infoMsgs: infoMsgs };
};

UserListPage.prototype._createEditConfirmationMsg = function( errorThrown )
{
    return new UserListConfirmation().createEditConfirmationMsg(errorThrown);
};

UserListPage.prototype._createDeleteConfirmationMsg = function( errorThrown )
{
    return new UserListConfirmation().createDeleteConfirmationMsg(errorThrown);
};

UserListPage.prototype._manageDepartmentsPopupClosedAndSmthChanged = function( departmentController ){
    var state = this._stateController.getState();
    var previouslySelectedGroupIds = state.userListFilter.groupIds;
    this._userGroupIdToGroupMap = {};
    var userIdToGroupIdMap = {};
    var self = this;

    this._allUserGroups = departmentController.storedData;
    $.each( departmentController.storedData,
                function (index, group){

                    if( group.id != SystemSettings.usersWithoutGroupId )
                        self._userGroupIdToGroupMap[ group.id ] = group;

                    $.each( group.users, function (index, user){
                            userIdToGroupIdMap[ user.id ] = group.id;
                    } )
    } );

    var userGroupWrappersList = this._getUserGroupWrappersList(state, previouslySelectedGroupIds);
    var timeZoneGroupWrappersList = this._getTimeZoneGroupWrappersList(state, previouslySelectedGroupIds);
    this._userGroupsSelector.getPanel().updateGroupsData(userGroupWrappersList, timeZoneGroupWrappersList);

    this._checkIfSelectedGroupWasDeleted();

    $.each(this._userListBody.find(".userRow"),
           function (index, row){
               var record = $(row).data().record;

               if ( !userIdToGroupIdMap[record.id] )     //if user was deleted but we see him at user list just skip
                    return true; //continue

               record.userGroupId = userIdToGroupIdMap[record.id];

               $(row).find(".accountTab-userGroupText-div" ).html( escapeHtmlSymbols( self._getGroupNameForRecord( record ) ) );
           });

};

UserListPage.prototype._manageTimeZoneGroupsPopupClosedAndSmthChanged = function(timeZoneGroupController)
{
    var state = this._stateController.getState();
    var previouslySelectedGroupIds = state.userListFilter.groupIds;
    this._timeZoneGroupIdToGroupMap = {};
    var userIdToGroupIdMap = {};
    var self = this;

    this._allTimeZoneGroups = timeZoneGroupController.storedData;
    $.each(timeZoneGroupController.storedData,
           function(index, group)
           {
               self._timeZoneGroupIdToGroupMap[group.id] = group;
               $.each(group.users, function(index, user)
               {
                   userIdToGroupIdMap[user.id] = group.id;
               })
           });


    var userGroupWrappersList = this._getUserGroupWrappersList(state, previouslySelectedGroupIds);
    var timeZoneGroupWrappersList = this._getTimeZoneGroupWrappersList(state, previouslySelectedGroupIds);
    this._userGroupsSelector.getPanel().updateGroupsData(userGroupWrappersList, timeZoneGroupWrappersList);

    this._checkIfSelectedGroupWasDeleted();

    $.each(this._userListBody.find(".userRow"),
           function(index, row)
           {
               var record = $(row).data().record;

               if (!userIdToGroupIdMap[record.id])     //if user was deleted but we see him at user list just skip
                   return true; //continue

               record.timeZoneGroupId = userIdToGroupIdMap[record.id];

               $(row).find(".accountTab-timeZoneGroupText-div").html(escapeHtmlSymbols(self._getTimeZoneGroupNameForRecord(record)));
           });

};

UserListPage.prototype._getUserGroupWrappersList = function(state, previouslySelectedGroupIds)
{
    return this._isUGREnabled() ?
           this._getGroupWrappersList(this._allUserGroups, this._userGroupIdToGroupMap,
                                      state.userListFilter.groupType == GroupType.USER_GROUP ? previouslySelectedGroupIds : {},
                                      true, SystemSettings.usersWithoutGroupId) :
           null;
};

UserListPage.prototype._getTimeZoneGroupWrappersList = function(state, previouslySelectedGroupIds)
{
    return this._isTZGEnabled() ?
           this._getGroupWrappersList(this._allTimeZoneGroups, this._timeZoneGroupIdToGroupMap,
                                      state.userListFilter.groupType == GroupType.TIME_ZONE_GROUP ? previouslySelectedGroupIds : {},
                                      false, DEFAULT_TIME_ZONE_GROUP_ID) :
           null;
};

UserListPage.prototype._checkIfSelectedGroupWasDeleted = function (){
    var state = this._stateController.getState();
    var previouslySelectedGroupIds = state.userListFilter.groupIds;
    var previouslySelectedGroupType = state.userListFilter.groupType;
    var groupIdToGroupMap = previouslySelectedGroupType == GroupType.USER_GROUP ?
        this._userGroupIdToGroupMap : this._timeZoneGroupIdToGroupMap;

    if( previouslySelectedGroupIds )
    {
        for( var i = 0; i < previouslySelectedGroupIds.length; i++ )
        {
            if(((previouslySelectedGroupType == GroupType.USER_GROUP && previouslySelectedGroupIds[i] != SystemSettings.usersWithoutGroupId) ||
                previouslySelectedGroupType != GroupType.USER_GROUP) &&
               !groupIdToGroupMap[ previouslySelectedGroupIds[i] ] )
            {
                this._onGroupSelectionChanged( this._userGroupsSelector.getSelection() );
                return;
            }
        }
    }
};

UserListPage.prototype._groupAssignmentsChangedCallback = function()
{
    var userListFilter = this._stateController.getProperty( "userListFilter" );
    var pageNum = this._stateController.getProperty( "pageNum" );
    if ( userListFilter.groupIds && pageNum === 1 ) {
        this._pagerController.loadPage(1);
    }
};

UserListPage.prototype._showManageDepartmentsPopup = function( departmentsChangedCallback )
{
    this._abortAllRequests();
    if( !this.manageDeparmentsController )
    {
        this.manageDeparmentsController = new APUserGroupManagementController();
        GroupManagementUtil.initializeGroupsLightBox(this.manageDeparmentsController, new UserGroupRenderer(), new GroupController(), new AddGroupController());
    }

    var self = this;

    var afterHideHandler = function () {
        self.manageDeparmentsController.hideLightboxHandler(
                function () {
                    departmentsChangedCallback( self.manageDeparmentsController );
                    self._groupAssignmentsChangedCallback();
                }
        );
    };

    var popup = createLightbox(
            "groupManagementLightBox",
            afterHideHandler,
            makeHandler( this.manageDeparmentsController.isPermitToHideLightbox, this.manageDeparmentsController ) );

    this.manageDeparmentsController.setLightbox( popup );
    this.manageDeparmentsController.initAfterShowing();
};

UserListPage.prototype._showManageTimeZoneGroupsPopup = function( timeZoneGroupsChangedCallback )
{
    this._abortAllRequests();
    if( !this.manageTimeZoneGroupsController )
    {
        this.manageTimeZoneGroupsController = GroupManagementUtil.initializeTimeZoneGroupsLightBox();
    }

    var self = this;

    var afterHideHandler = function () {
        self.manageTimeZoneGroupsController.hideLightboxHandler(
                function () {
                    timeZoneGroupsChangedCallback( self.manageTimeZoneGroupsController );
                    self._groupAssignmentsChangedCallback();
                }
        );
    };

    var popup = createLightbox(
            "timeZoneGroupManagementLightBox",
            afterHideHandler,
            makeHandler( this.manageTimeZoneGroupsController.isPermitToHideLightbox, this.manageTimeZoneGroupsController ) );

    this.manageTimeZoneGroupsController.setLightbox( popup );
    this.manageTimeZoneGroupsController.initAfterShowing();
};


UserListPage.prototype._getGroupWrappersList = function ( sortedGroupList, groupIdToNameMap, selectedGroupsArray, includeNullGroup, defaultGroupId )
{
    if( !selectedGroupsArray )
    {
        selectedGroupsArray = [];
    }
    var selectedGroupsSet = {};
    $.each( selectedGroupsArray, function ( idx, groupId ) { selectedGroupsSet[groupId] = true; } );

    var allGroups = [];
    if (includeNullGroup) {
        allGroups.push({
            id: SystemSettings.usersWithoutGroupId,
            name: messageResource.getMessage('common.users_without_group')
        });
    }
    allGroups = allGroups.concat( jQuery.map( sortedGroupList, function ( group ) {return groupIdToNameMap[group.id];} ) );

    allGroups = jQuery.map( allGroups, function ( group )
    {
        return {
            id: group.id,
            name: group.name,
            selected: selectedGroupsSet[group.id] === true,
            isDefault: group.id == defaultGroupId
        }
    } );

    return allGroups;
};

UserListPage.prototype.getCurrentTime =function( timeZoneGroupId, successCallback, errorCallback )
{
    makeRpcCall( "CurrentTimeInfoService.getCurrentTimeInfo", [timeZoneGroupId], successCallback, errorCallback);
};


/**
 * @static
 */
UserListPage.prototype.removeRow = function ( userId )
{
    UserListPage.removeRow(this.userIdRowMap[userId]);
};


/**
 * @static
 */
UserListPage.removeRow = function ( row )
{
    row = $( row );
    if( row.hasClass( "apUserListNewUser" ) )
    {
        row.next().remove();
        if( row.prev().hasClass( "apUserListTopSpacer" ) && !row.next().hasClass( "apUserListNewUser" ) )
            row.prev().remove();
    }

    row.remove();

    PageOverlayTipsManager.getInstance().refreshDynamicTips();
};

export default UserListPage;



// WEBPACK FOOTER //
// ./web/actiplans/js/administration/UserListPage.js